// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:16:14.257Z
// Property: Legacy at River Crossing (ID: 6737460151191760)
// Collections: 33 amenities, 16 floorplans (live), 43 photos, 73 POIs, 4 reviews, 1 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191760",
  "property_external_id": "4857249",
  "property_zillow_url": "https://www.zillow.com/apartments/macon-ga/legacy-at-river-crossing/5XhtFX/",
  "property_apartments_url": "https://www.apartments.com/legacy-at-river-crossing-macon-ga/g76sjwy",
  "property_google_business_url": "https://www.google.com/maps/place/Legacy+at+River+Crossing/data=!4m2!3m1!1s0x0:0xc750c43ea22709a8?sa=X&ved=2ahUKEwjuoqPeurySAxWCQTABHdQaFwQQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "17321198228",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "legacy-at-river-crossing",
  "property_name": "Legacy at River Crossing",
  "property_website_url": "https://www.legacyatrivercrossing.com/",
  "property_domain": "https://www.legacyatrivercrossing.com/",
  "property_address": "1800 Wesleyan Dr",
  "property_full_address": "1800 Wesleyan Dr, Macon, GA 31210",
  "property_address_1": "1800 Wesleyan Dr",
  "property_address_2": null,
  "property_address_city": "Macon",
  "property_address_state": "GA",
  "property_address_zip_full": "31210-1001",
  "property_address_zip": "31210",
  "property_address_country": "US",
  "property_address_county": "Bibb County",
  "property_neighborhood_address": "Bibb County",
  "property_address_latitude": "32.9266211",
  "property_address_longitude": "-83.71958149999999",
  "property_email": "legacyrivercrossing@rreafresidential.com",
  "property_phone": "(478) 217-7009",
  "property_call_tracking_phone": "478-606-1784",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Legacy at River Crossing in Macon, GA, the perfect blend of comfort and style awaits you. Choose from our diverse floor plans—one, two, or three bedrooms—and enjoy unparalleled amenities, including short-term lease options and competitive pricing. Your ideal home is just a click away; schedule your tour today!",
  "property_long_description": "**Discover Your Ideal Home at Legacy at River Crossing in Macon, GA**\n\nWelcome to Legacy at River Crossing, where comfort meets convenience! Nestled in the heart of Macon, GA, our stunning apartment community offers an array of thoughtfully designed floor plans to suit your lifestyle. Choose from our inviting one, two, or three-bedroom apartments, each tailored to bring you warmth and tranquility. \n\nAt Legacy at River Crossing, residents enjoy flexible leasing options, including short-term leases, making it easy to find the perfect fit for your stay. As a proud price leader in the area, we believe that exceptional living shouldn’t break the bank. Our community amenities are designed to elevate your living experience, from spacious layouts and cozy interiors to convenient access to nearby shops and attractions. \n\nExplore our diverse selection of homes and imagine your new life in a vibrant neighborhood that balances leisure with city connectivity. Whether you’re looking for a cozy one-bedroom retreat or a spacious three-bedroom for your family, you’ll find the perfect space that reflects your lifestyle.\n\nReady to take the next step? Find your new home today by browsing our availability or scheduling a tour to visit our welcoming community. Experience the ease and comfort of apartment living at Legacy at River Crossing—where every day feels like a getaway!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d65-df5d-74c4-b0e2-9214e5ca2090.webp",
  "property_featured_image_media": {
    "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
    "public_id": "01a06d65-df5d-74c4-b0e2-9214e5ca2090",
    "storage_key": "property/6737460151191760/01a06d65-df5d-74c4-b0e2-9214e5ca2090.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "200",
  "property_year_built": "1987",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "One-Time Move-In Fees\nAdministrative Fee\n$150\nApplication Fee\n$65",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "3",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "If animals are accepted at the RREAF Residential community where application is made, no more than two animals are allowed per apartment. Aggressive breeds will not be allowed. A non-refundable pet fee, monthly pet rent and prior approval from management will be required for each pet.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://legacyatrivercrossing.loftliving.com/login",
  "property_apply_now_url": "https://8747932.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-7abf-714d-8dcb-756418197c4f.webp",
  "property_primary_logo_media": {
    "alt_text": "Legacy at River Crossing Apartment Homes logo.",
    "public_id": "019e1e40-7abf-714d-8dcb-756418197c4f",
    "storage_key": "property/6737460151191760/019e1e40-7abf-714d-8dcb-756418197c4f.webp",
    "width": 300,
    "height": 238
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-7abf-714d-8dcb-756418197c4f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Legacy at River Crossing Apartment Homes logo.",
    "public_id": "019e1e40-7abf-714d-8dcb-756418197c4f",
    "storage_key": "property/6737460151191760/019e1e40-7abf-714d-8dcb-756418197c4f.webp",
    "width": 300,
    "height": 238
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-7abf-714d-8dcb-756418197c4f.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Legacy at River Crossing Apartment Homes logo.",
    "public_id": "019e1e40-7abf-714d-8dcb-756418197c4f",
    "storage_key": "property/6737460151191760/019e1e40-7abf-714d-8dcb-756418197c4f.webp",
    "width": 300,
    "height": 238
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-7a7a-70be-adde-1236fd0be4e0.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Legacy at River Crossing Apartment Homes logo",
    "public_id": "019e1e40-7a7a-70be-adde-1236fd0be4e0",
    "storage_key": "property/6737460151191760/019e1e40-7a7a-70be-adde-1236fd0be4e0.webp",
    "width": 300,
    "height": 238
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#123454",
  "property_secondary_color": "#2695ab",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "745 - 1250",
  "property_sqft_min": "745",
  "property_sqft_max": "1250",
  "property_price_range": "1530",
  "property_price_min": "975",
  "property_price_max": "1530",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61554716871808",
  "property_instagram_url": "https://www.instagram.com/legacy_at_river_crossing/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJBc8n5YEH9IgRqAknoj7EUMc",
  "property_youtube_url": "https://www.youtube.com/watch?v=eqeNinHAVxw",
  "property_yelp_url": "https://www.yelp.com/biz/legacy-at-wesleyan-corners-macon-2",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Legacy at River Crossing",
  "property_home_romance_title": "Love Where You Live: Your Ideal Apartment Awaits",
  "property_home_amenities_blurb": "<p>If you are ready for <a href=\"/floor-plans/\">resort-style living</a> in southeastern Georgia, then it’s time to call the Legacy at River Crossing apartments home! <a href=\"/neighborhood/\">Located in Macon</a>, we boast close proximity to many fun entertainment and outdoor recreational opportunities. The essentials are nearby, too; great restaurants, shopping, hiking trails, and other facilities. An exciting new lifestyle awaits you at these pet-friendly apartments for rent in Macon, GA!</p>",
  "property_home_floorplans_blurb": "<p>Ideally located in Macon, GA, the neighborhood surrounding Legacy at River Crossing has so much to offer. Entertainment, restaurants, schools, & services combine to create a <a href=\"/floor-plans/\">conveniently placed home</a>. Check out the neighborhood!</p>",
  "property_home_gallery_blurb": "At Legacy at River Crossing in Macon, GA, every detail enhances your lifestyle. Choose from spacious one, two, or three-bedroom floor plans, all featuring modern amenities such as a fitness center, pool, and pet-friendly areas. With vibrant social activities and serene courtyards, picture yourself living in a community that feels like home!",
  "property_home_neighborhood_blurb": "At Legacy at River Crossing in Macon, GA, your perfect home awaits with thoughtfully designed one, two, and three-bedroom floor plans. Surround yourself with vibrant local favorites and hidden gems just a stone's throw away. Uncover the essence of community living and relish the charm that awaits outside your door.",
  "property_home_reviews_blurb": "Welcome to Legacy at River Crossing, where comfort meets convenience in Macon, GA. Our residents rave about the \"warm and welcoming\" staff that truly makes you feel at home. Enjoy easy access to shopping and dining, all in a beautifully kept community. Join us and experience quality living today!",
  "property_neighborhood_blurb": "<p>Ideally located in Macon, GA, the neighborhood surrounding Legacy at River Crossing has so much to offer. Entertainment, restaurants, schools, & services combine to create a <a href=\"/floor-plans/\">conveniently placed home</a>. Check out the neighborhood!</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>When outside of <a href=\"/floor-plans/\">your apartment home</a>, there is much to do in our fun and <a href=\"/neighborhood/\">exciting environment</a>. Go for a swim, play some foosball on the sports court, or have a barbecue in the picnic area. Invite some friends for an outdoor gathering around the fire pit or a relaxing visit in the clubhouse. These are just some of the premium amenities that await you at Legacy at River Crossing apartments in Macon, Georgia.</p>",
  "property_applynow_blurb": "At Legacy at River Crossing in Macon, GA, your perfect home awaits! Choose from thoughtfully designed one, two, or three-bedroom floor plans. Enjoy the flexibility of short-term leasing, all at competitive prices. Embrace comfort and convenience—find your new sanctuary and lease online today!",
  "property_contactus_blurb": "At Legacy at River Crossing in Macon, GA, we offer thoughtfully crafted floor plans tailored to your lifestyle—choose from one, two, or three-bedroom layouts that blend comfort and elegance. Curious? Our leasing team is ready to assist you with your inquiries. Reach out today to start your journey home!",
  "property_faqs_blurb": "At Legacy at River Crossing in Macon, GA, we cater to diverse lifestyles with spacious one, two, and three-bedroom floor plans. Have questions about our community? Our FAQs page is your go-to resource for insights that can help you find your perfect home. Explore the answers today!",
  "property_floorplans_blurb": "<p>You can take your pets for a stroll around our <a href=\"/neighborhood/\">beautiful neighborhood</a> or <a href=\"/amenities/\">visit one of the many parks in the area</a>. When at home in your new one, two, or three bedroom apartment, you can step out onto your balcony or patio for a breath of fresh air. Fully-equipped kitchens have everything you need, including a pantry, refrigerator with ice maker, and black appliance options are available. Enjoy meals in your separate dining area, and you can choose the additional space of a bright sunroom!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/amenities/\">community</a> and <a href=\"/floor-plans/\">apartments.</a></p>",
  "property_interactivemap_blurb": "At Legacy at River Crossing in Macon, GA, experience a harmonious blend of comfort and convenience with our spacious one, two, and three-bedroom floor plans. Enjoy the flexibility of short-term leases and discover unbeatable pricing. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Legacy at River Crossing in Macon, GA, your ideal home awaits! Choose from spacious one, two, or three-bedroom floor plans tailored for modern living. Great friends make great neighbors—refer a friend to join our vibrant community today and create lasting memories together!",
  "property_residentaccess_blurb": "Welcome to Legacy at River Crossing in Macon, GA, where comfort meets convenience. Choose from our thoughtfully designed one, two, or three-bedroom floor plans. Ready to take charge of your living experience? Access your resident portal now for seamless rent payment, easy maintenance scheduling, and a world of community services at your fingertips!",
  "property_reviews_blurb": "At Legacy at River Crossing, residents cherish a quality living experience in Macon, GA. With an outstanding 4-star rating, our welcoming staff goes above and beyond—“...the management is the best... they pay attention to you as a person.” Join a community where comfort and care intertwine seamlessly!",
  "property_created_at": "1752257091684",
  "property_scheduletour_blurb": "At Legacy at River Crossing in Macon, GA, spacious floor plans await you—choose from one, two, or three-bedroom layouts that perfectly fit your lifestyle. Experience vibrant community living and read our residents' glowing testimonials. Ready to see your future home? Schedule a tour today and step into your new haven!",
  "property_thankyou_blurb": "At Legacy at River Crossing in Macon, GA, spacious one, two, and three-bedroom floor plans await your unique touch. Thank you for reaching out! Our team will connect with you soon to help you find your perfect home that complements your lifestyle. Your new adventure starts here!",
  "property_virtualtours_blurb": "<p>At Legacy at River Crossing, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. Legacy at River Crossing",
  "property_seo_title_home": "Legacy at River Crossing | Apartments in Macon, GA",
  "property_seo_description_home": "Experience the charm of Legacy at River Crossing in beautiful Macon, GA. Choose from spacious one, two, and three-bedroom apartments designed for comfort and style. Enjoy the flexibility of short-term leases and benefit from our competitive pricing. Your ideal living space awaits—make it yours today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Macon, GA",
  "property_seo_description_floorplans": "Experience the charm of Macon, GA at Legacy at River Crossing, where modern living meets comfort. Choose from our thoughtfully designed floor plans, including cozy one-bedroom retreats, spacious two-bedroom suites, and expansive three-bedroom homes. Each space is crafted to fit your lifestyle. Browse our available apartment homes today and uncover your ideal living arrangement!",
  "property_seo_title_amenities": "Amenities | Macon, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience elevated living at Legacy at River Crossing in Macon, GA, where style meets comfort. Choose from spacious one, two, and three-bedroom floor plans tailored to your lifestyle. Enjoy the flexibility of short-term leases and unbeatable pricing, all within a vibrant community that feels like home. Dive into luxurious amenities that make everyday living extraordinary—your perfect sanctuary awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Macon, GA",
  "property_seo_description_gallery": "\"Immerse yourself in the charm of Legacy at River Crossing in Macon, GA. Our stunning photo gallery showcases beautifully designed one, two, and three-bedroom apartments, complete with top-tier amenities like short-term lease options and unbeatable pricing. Picture your ideal lifestyle here—where comfort meets convenience!\"",
  "property_seo_title_virtualtours": "Virtual Tours | Legacy at River Crossing Apartments",
  "property_seo_description_virtualtours": "Experience the charm of Legacy at River Crossing in Macon, GA, where modern living meets southern hospitality. From cozy one-bedroom retreats to spacious three-bedroom layouts, our thoughtfully designed floor plans cater to every lifestyle. Ready to envision your future home? Take a virtual tour of our vibrant community and well-appointed apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | Legacy at River Crossing Apartments",
  "property_seo_description_interactivemap": "Uncover your ideal living space at Legacy at River Crossing in vibrant Macon, GA. Whether you're looking for a cozy one-bedroom or a spacious three-bedroom apartment, our interactive community map lets you navigate available options and pricing with ease. With flexible short-term lease options and competitive pricing, finding your new home has never been simpler. Dive in now and see how Legacy at River Crossing can elevate your lifestyle!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Macon, GA",
  "property_seo_description_neighborhood": "Experience the vibrant lifestyle of Legacy at River Crossing in Macon, GA! Nestled in a thriving neighborhood, our community offers an array of local favorites and unique attractions just moments away. Whether you're searching for cozy cafes, parks, or shopping hotspots, there's something for everyone. Uncover the perfect blend of comfort and convenience—your new adventure awaits just outside your door!",
  "property_seo_title_contact": "Contact Us | Legacy at River Crossing",
  "property_seo_description_contact": "\"At Legacy at River Crossing in Macon, GA, your ideal home awaits. From cozy one-bedroom to spacious three-bedroom floor plans, we offer the perfect layout to suit your lifestyle. Whether you're looking to downsize or find a family-friendly space, our community is designed with you in mind. Have questions? Contact our leasing team today for personalized assistance!\"",
  "property_seo_title_faqs": "FAQs | Apartments in Macon, GA",
  "property_seo_description_faqs": "Unlock the secrets of apartment living at Legacy at River Crossing in Macon, GA. From chic one-bedroom retreats to spacious three-bedroom havens, our price leader floor plans cater to your lifestyle. Wondering about short-term leases or community amenities? Our FAQs page is your go-to resource for everything you need to know. Get informed and find your perfect home today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Macon, GA",
  "property_seo_description_reviews": "Experience the vibrant lifestyle at Legacy at River Crossing in Macon, GA, where our residents thrive. From spacious one to three-bedroom floor plans, we offer comfort and convenience in a price-leading community. Short-term leases cater to your flexibility, while our resident reviews showcase the true spirit of living here. Dive into the voices of our community and see why Legacy is the perfect place to call home!",
  "property_seo_title_applynow": "Apply Now | Apartments in Macon, GA",
  "property_seo_description_applynow": "Unlock the door to your dream living space at Legacy at River Crossing in Macon, GA! Choose from stylish one, two, or three-bedroom floor plans and enjoy the flexibility of short-term leases at unbeatable prices. Ready to call this vibrant community home? Start your application and lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Legacy at River Crossing",
  "property_seo_description_residentaccess": "\"Welcome back to Legacy at River Crossing, where your comfort meets convenience. Log in to your resident portal and effortlessly manage your living experience in Macon, GA—pay rent, schedule maintenance, and enjoy exclusive community updates all in one place!\"",
  "property_seo_title_referafriend": "Refer A Friend | Legacy at River Crossing",
  "property_seo_description_referafriend": "\"At Legacy at River Crossing in Macon, GA, your circle just got wider! Share the joy of exceptional living—refer a friend today and embrace a community where great friends become great neighbors. Let’s build a vibrant home together!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Legacy at River Crossing",
  "property_seo_description_scheduletour": "\"Step into a lifestyle of comfort and community at Legacy at River Crossing in Macon, GA. Experience spacious apartments, stunning amenities, and picturesque surroundings. Ready to see it all? Schedule a tour today and envision your new home!\"",
  "property_seo_title_privacy": "Privacy Policy | Legacy at River Crossing",
  "property_seo_description_privacy": "Safeguarding your personal information is our priority at Legacy at River Crossing. Dive into our comprehensive Privacy Policy to see how we protect your data while you enjoy the serenity of Macon living. View our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | Legacy at River Crossing",
  "property_seo_description_accessibility": "\"At Legacy at River Crossing in Macon, GA, we prioritize accessibility and inclusion for all. Our commitment to digital ease ensures every resident experiences seamless navigation. Join us in fostering a community where everyone belongs!\"",
  "property_seo_title_sitemap": "Sitemap | Legacy at River Crossing",
  "property_seo_description_sitemap": "\"Navigate your future at Legacy at River Crossing in Macon, GA. Our sitemap conveniently outlines every amenity and feature, ensuring you find the perfect space that suits your lifestyle. Dive into all that our vibrant community has to offer!\"",
  "property_seo_title_thankyou": "Thank You | Legacy at River Crossing",
  "property_seo_description_thankyou": "Thank you for reaching out to Legacy at River Crossing! Your interest in our vibrant Macon community is appreciated. Our team is eager to connect and help you find your perfect home. Stay tuned for a prompt response as we guide you through your next chapter in comfortable living!",
  "property_seo_title_pets": "Pet Policy | Apartments in Macon, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293647737",
  "amenities": [
    {
      "id": "custom_37b93a1f-c607-482c-b660-60e73834daa1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Apartments Available!",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc202fc0-07a9-49f9-a88a-185eaed990b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Access to Public Transportation",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6bef16fc-3a3c-434f-b1da-0cc7d2781d58",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_becd6df8-6315-45c6-8a88-43a7d702a7de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8d9afb52-f5f2-4b97-83de-4b0d94a7c5d0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Easy Access to Freeways and Shopping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ceb10c3a-9fdb-41d1-922f-f05d4e47e1a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e5651e5-0a67-4969-94f0-fb85c4e3ee3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Laundry Facility",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3605b25c-ba52-4410-aedd-708d4b838e07",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "On‑call and On‑site Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5c6f744c-f0ee-4306-9f35-13c6ffd8af66",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Lounge with Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_12be3f00-0cc9-4fd0-aded-f087bf03e436",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Package Acceptance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_89bff7e3-4a80-460b-97fc-87afa5d56009",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3c9390ac-87fc-4fb1-87bc-08efdc34a607",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Picnic Area with Barbecues",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f0d7d69a-3ae4-457e-a23d-310832ffafc6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a085f6ab-db9c-4a00-afbe-e0ae41fe1411",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_743d8c7c-c00a-4243-8194-7c175ced2738",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Short‑term Leasing Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_af95f054-3daf-4dca-999d-d815403a701b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Sports Court",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_06bc5281-bab6-414a-bc54-137fb0e31fdd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Valet Trash Services",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ea28ee11-1e96-40be-9d28-a5bbfb72e1a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Wi‑Fi Available at Clubhouse and Pool",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aed27328-f7a3-4362-b1c5-f17ca874a5c5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Balcony or Patio",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ae61fba9-8ccc-43c0-add1-167505a3a351",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_aea426ec-c1d0-4fe6-b681-bab29a054c1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6badc9ce-4ddb-4319-a616-1e7b633b0ee7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Dining Room",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_22a949c2-f74a-407e-be8e-7aaabca36ec1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Extra Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_540dd836-6183-47f9-8f85-cc9904b2e8b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "One Month Free Internet with Cox",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9d3e2877-9ccf-42b5-b0fb-b1922848b324",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Pantry",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9eba6bd7-0991-4383-8b87-560b32dac5fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Personal Sunrooms Available*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dbff318d-f3be-4479-b1e5-8d1fb989a2ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Refrigerator with Ice Maker",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0383b4d4-9a0d-4f39-a441-9739af30e75f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Walk‑in Closets*",
      "amount": "false",
      "description": "In Select Apartment Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_485a46c6-4475-4d15-9b29-c0caad79ee5b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Washer and Dryer Connections",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_782dc0ef-0619-4d44-8301-8ae8b5cafb67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑style Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4f07d984-abac-43b4-aaf8-b98ed9ac572b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c2bf1a7f-65de-4113-9ff6-5c4129a8e2f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Backsplash*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5e45cf8a-8f32-4f78-aab3-90660d943c24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "external_id": "false",
      "title": "Granite-Look Countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_339a7b23-5fef-41ab-a8c5-17ad364942f1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-b3bc-739f-9749-73c486376510.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a06d67-b3bc-739f-9749-73c486376510",
        "storage_key": "property/6737460151191760/01a06d67-b3bc-739f-9749-73c486376510.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable seating.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0600113f-97cb-4f0d-bbfa-275e124360ef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d65-df5d-74c4-b0e2-9214e5ca2090.webp",
      "image_media": {
        "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
        "public_id": "01a06d65-df5d-74c4-b0e2-9214e5ca2090",
        "storage_key": "property/6737460151191760/01a06d65-df5d-74c4-b0e2-9214e5ca2090.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for ultimate relaxation.",
      "link": "",
      "alt_text": "Sparkling blue swimming pool with lounge chairs and umbrellas on a sunny day.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6e791b5a-d963-452a-958f-d129b18e3807",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-ac9b-775f-bab5-9a57652e6495.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "01a06d67-ac9b-775f-bab5-9a57652e6495",
        "storage_key": "property/6737460151191760/01a06d67-ac9b-775f-bab5-9a57652e6495.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Beautifully updated kitchen featuring stainless steel appliances, ample cabinet space, and elegant granite countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6f5ab3f9-1c3d-49d8-852f-f3589cd99d71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-ac39-73d1-bb08-0884c636b8d9.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen of a multifamily apartment unit.",
        "public_id": "01a06d67-ac39-73d1-bb08-0884c636b8d9",
        "storage_key": "property/6737460151191760/01a06d67-ac39-73d1-bb08-0884c636b8d9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Elegant dining area with a round table set for four, adjacent to a modern kitchen with stainless steel appliances. Offers a spacious and inviting atmosphere.",
      "link": "",
      "alt_text": "Dining area and kitchen of a multifamily apartment unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2eb2be40-c86a-402f-b2d8-981d88356d9a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-b2f9-73dc-93e1-3c6021fd9542.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, ceiling fan, and window.",
        "public_id": "01a06d67-b2f9-73dc-93e1-3c6021fd9542",
        "storage_key": "property/6737460151191760/01a06d67-b2f9-73dc-93e1-3c6021fd9542.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable queen-size bed, elegant ceiling fan, and large window for natural light.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, ceiling fan, and window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_61d815d3-5ac1-4560-9fc1-ff7439252264",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-b344-738f-9394-c5ae01d8b6e3.webp",
      "image_media": {
        "alt_text": "A bedroom with a king-sized bed, a ceiling fan, and a window with blinds.",
        "public_id": "01a06d67-b344-738f-9394-c5ae01d8b6e3",
        "storage_key": "property/6737460151191760/01a06d67-b344-738f-9394-c5ae01d8b6e3.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a plush king-sized bed, modern ceiling fan, and ample natural light.",
      "link": "",
      "alt_text": "A bedroom with a king-sized bed, a ceiling fan, and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_49fc0e4a-5c05-4008-bd84-6cc8ecd0473b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-ab99-701c-86fc-95cc77a218e9.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a fireplace, comfortable seating, and large windows.",
        "public_id": "01a06d67-ab99-701c-86fc-95cc77a218e9",
        "storage_key": "property/6737460151191760/01a06d67-ab99-701c-86fc-95cc77a218e9.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace and ample seating for socializing or quiet enjoyment.",
      "link": "",
      "alt_text": "Modern lounge area with a fireplace, comfortable seating, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0d3a1522-0b2c-4186-aa10-d16c8f998299",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-ac43-736c-9a39-8dd412499fa6.webp",
      "image_media": {
        "alt_text": "Exterior view of the community clubhouse with a well-manicured lawn and trees.",
        "public_id": "01a06d67-ac43-736c-9a39-8dd412499fa6",
        "storage_key": "property/6737460151191760/01a06d67-ac43-736c-9a39-8dd412499fa6.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Community",
      "description": "Charming exterior of the community clubhouse, surrounded by lush greenery and providing a welcoming ambiance.",
      "link": "",
      "alt_text": "Exterior view of the community clubhouse with a well-manicured lawn and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_66b25ae7-0b44-48ce-84b8-59e7d78319d7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-b47d-72ed-9d0b-7718a762d78a.webp",
      "image_media": {
        "alt_text": "Outdoor recreation area with picnic tables, cornhole boards, and horseshoe pits.",
        "public_id": "01a06d67-b47d-72ed-9d0b-7718a762d78a",
        "storage_key": "property/6737460151191760/01a06d67-b47d-72ed-9d0b-7718a762d78a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy outdoor fun and games in our community's recreation area, featuring picnic tables, cornhole, and horseshoe pits for resident enjoyment.",
      "link": "",
      "alt_text": "Outdoor recreation area with picnic tables, cornhole boards, and horseshoe pits.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2b08b919-5037-48f0-948a-754468473ace",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-795a-7563-9d8f-18f0f26f48da.webp",
      "image_media": {
        "alt_text": "Living room and dining area with a sofa, coffee table, dining table, and chairs.",
        "public_id": "019e852e-795a-7563-9d8f-18f0f26f48da",
        "storage_key": "property/6737460151191760/019e852e-795a-7563-9d8f-18f0f26f48da.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Apartment",
      "description": "Step into this beautifully furnished living and dining area, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room and dining area with a sofa, coffee table, dining table, and chairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8963d65c-ce52-4b9d-ae73-6dfcaac5c21a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/01a06d67-a9dd-716e-b429-1a2c40d8d92b.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and window",
        "public_id": "01a06d67-a9dd-716e-b429-1a2c40d8d92b",
        "storage_key": "property/6737460151191760/01a06d67-a9dd-716e-b429-1a2c40d8d92b.webp",
        "width": 2000,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, plush carpeting, and a large window offering natural light.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and window",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_09a6b9a8-725f-4f1b-951e-baaa613bc22f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-788c-708b-a494-ba40100130c5.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and shower with blue leaf pattern curtain.",
        "public_id": "019e852e-788c-708b-a494-ba40100130c5",
        "storage_key": "property/6737460151191760/019e852e-788c-708b-a494-ba40100130c5.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Apartment",
      "description": "A modern bathroom featuring a white vanity with a granite countertop, a stainless steel faucet, and a large mirror. It includes a toilet with a decorative plant and a shower with a blue leaf patterned curtain.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and shower with blue leaf pattern curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_939ecf39-1add-4b5d-8753-2704fc986b64",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-7feb-74ac-8133-a1f821909186.webp",
      "image_media": {
        "alt_text": "Fitness center gym with treadmills, ellipticals, and weight machines.",
        "public_id": "019e852e-7feb-74ac-8133-a1f821909186",
        "storage_key": "property/6737460151191760/019e852e-7feb-74ac-8133-a1f821909186.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring modern cardio machines and strength training equipment for a complete workout.",
      "link": "",
      "alt_text": "Fitness center gym with treadmills, ellipticals, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_04b3151c-ef4c-429f-9fa9-9a675b8d5585",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-84ef-775d-a9c7-616a89b32281.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with built-in grills, seating, and umbrellas.",
        "public_id": "019e852e-84ef-775d-a9c7-616a89b32281",
        "storage_key": "property/6737460151191760/019e852e-84ef-775d-a9c7-616a89b32281.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and entertaining at our community grilling station, complete with multiple grills and comfortable seating under refreshing umbrellas.",
      "link": "",
      "alt_text": "Outdoor grilling area with built-in grills, seating, and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_96e2c2d2-ea14-402a-b612-d0fd10cf17e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-84e4-765c-ad08-601a23c7a732.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with fire pit and pool view.",
        "public_id": "019e852e-84e4-765c-ad08-601a23c7a732",
        "storage_key": "property/6737460151191760/019e852e-84e4-765c-ad08-601a23c7a732.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling pool or gather around the fire pit with friends and neighbors in our beautifully landscaped community courtyard.",
      "link": "",
      "alt_text": "Outdoor seating area with fire pit and pool view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cb313ba9-b70b-4beb-bd19-53a0d896346e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-813d-7627-b465-2f3ee15b7ee0.webp",
      "image_media": {
        "alt_text": "Treadmills, ellipticals, and stationary bikes in a well-lit fitness center with large windows.",
        "public_id": "019e852e-813d-7627-b465-2f3ee15b7ee0",
        "storage_key": "property/6737460151191760/019e852e-813d-7627-b465-2f3ee15b7ee0.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring a variety of cardio machines and free weights for a complete workout.",
      "link": "",
      "alt_text": "Treadmills, ellipticals, and stationary bikes in a well-lit fitness center with large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5784aa8f-7e00-472f-8892-1c4ea10077af",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-7e91-747c-9a6a-9812ed75aa5e.webp",
      "image_media": {
        "alt_text": "Living room with large wall clock, sofa, coffee table, and sliding glass door.",
        "public_id": "019e852e-7e91-747c-9a6a-9812ed75aa5e",
        "storage_key": "property/6737460151191760/019e852e-7e91-747c-9a6a-9812ed75aa5e.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Apartment",
      "description": "Relax in this stylish living room featuring a statement clock, comfortable seating, and a bright, airy atmosphere. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Living room with large wall clock, sofa, coffee table, and sliding glass door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed50d974-6ac2-4de2-9f16-a32aca692f94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-61cf-75ee-98ad-149e09be013b.webp",
      "image_media": {
        "alt_text": "Luxurious community lounge with fireplace, comfortable seating, and view of the pool area.",
        "public_id": "019e852e-61cf-75ee-98ad-149e09be013b",
        "storage_key": "property/6737460151191760/019e852e-61cf-75ee-98ad-149e09be013b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring a cozy fireplace and ample seating. Enjoy the beautiful views of the outdoor pool area.",
      "link": "",
      "alt_text": "Luxurious community lounge with fireplace, comfortable seating, and view of the pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51df18c5-06bf-4e49-a77b-713e77df02a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-5f54-70ca-8293-04802f87a2bb.webp",
      "image_media": {
        "alt_text": "Kitchen with gray cabinets, black appliances, and a dog portrait.",
        "public_id": "019e852e-5f54-70ca-8293-04802f87a2bb",
        "storage_key": "property/6737460151191760/019e852e-5f54-70ca-8293-04802f87a2bb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring gray cabinetry, stainless steel appliances, and a decorative dog painting on the wall. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Kitchen with gray cabinets, black appliances, and a dog portrait.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8e087cbd-362c-4879-bf8d-9b8be9701e6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-5fd7-727a-984a-f66957102c64.webp",
      "image_media": {
        "alt_text": "Spacious community lounge area with comfortable seating and a modern chandelier.",
        "public_id": "019e852e-5fd7-727a-984a-f66957102c64",
        "storage_key": "property/6737460151191760/019e852e-5fd7-727a-984a-f66957102c64.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully designed community lounge, featuring ample seating, a stylish chandelier, and a fully equipped kitchen.",
      "link": "",
      "alt_text": "Spacious community lounge area with comfortable seating and a modern chandelier.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f835a0e-52c3-42f1-9a61-e5035f297db6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-5fe0-75dd-a939-6c1a6c6e6213.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and a coffee station.",
        "public_id": "019e852e-5fe0-75dd-a939-6c1a6c6e6213",
        "storage_key": "property/6737460151191760/019e852e-5fe0-75dd-a939-6c1a6c6e6213.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy a convenient coffee bar in this modern kitchen, complete with stainless steel appliances and ample counter space.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and a coffee station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e29852e3-daee-4a57-a1db-99476821c19e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-5f97-77cb-a7e8-87c33210876f.webp",
      "image_media": {
        "alt_text": "Office desk with computer and chairs, with a large whiteboard on the wall.",
        "public_id": "019e852e-5f97-77cb-a7e8-87c33210876f",
        "storage_key": "property/6737460151191760/019e852e-5f97-77cb-a7e8-87c33210876f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Well-appointed office space featuring a modern desk, computer setup, and a whiteboard for management tasks. Ideal for property staff operations.",
      "link": "",
      "alt_text": "Office desk with computer and chairs, with a large whiteboard on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33348c68-2e59-4c38-b520-9d74dd49a22c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-58fa-707c-9056-45b91a36a48b.webp",
      "image_media": {
        "alt_text": "A table and chairs in a common area with a TV mounted on the wall and abstract art.",
        "public_id": "019e852e-58fa-707c-9056-45b91a36a48b",
        "storage_key": "property/6737460151191760/019e852e-58fa-707c-9056-45b91a36a48b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather with neighbors or catch up on your favorite shows in this comfortable common area, complete with a TV and seating.",
      "link": "",
      "alt_text": "A table and chairs in a common area with a TV mounted on the wall and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_84556bbd-0c02-44ef-a075-868dbad70996",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-4fc1-70a3-b536-6fda96c3c125.webp",
      "image_media": {
        "alt_text": "Outdoor recreational area with picnic tables and cornhole games.",
        "public_id": "019e852e-4fc1-70a3-b536-6fda96c3c125",
        "storage_key": "property/6737460151191760/019e852e-4fc1-70a3-b536-6fda96c3c125.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation with picnic tables and cornhole games on the spacious green lawn.",
      "link": "",
      "alt_text": "Outdoor recreational area with picnic tables and cornhole games.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2859bab4-a52a-43df-9dc5-e9c5c8f8d84a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-3eb2-75d3-90b0-d021333d3886.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with high-top tables, chairs, and built-in grills under a pergola.",
        "public_id": "019e852e-3eb2-75d3-90b0-d021333d3886",
        "storage_key": "property/6737460151191760/019e852e-3eb2-75d3-90b0-d021333d3886.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining and grilling in our spacious outdoor patio area, complete with comfortable seating and modern grills.",
      "link": "",
      "alt_text": "Outdoor patio area with high-top tables, chairs, and built-in grills under a pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ec1d9d06-3924-4076-a11c-1b10e14cff49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-328a-70dd-a45e-e949bfc7a428.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment including tunnels, ramps, and jumps.",
        "public_id": "019e852e-328a-70dd-a45e-e949bfc7a428",
        "storage_key": "property/6737460151191760/019e852e-328a-70dd-a45e-e949bfc7a428.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our dedicated dog park, featuring fun agility equipment for your furry friends to play and exercise in.",
      "link": "",
      "alt_text": "Dog park with agility equipment including tunnels, ramps, and jumps.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ff53c0b2-5db3-43f3-987e-429178a1bca1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-3a11-774b-b098-4dc2a82d5473.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and lush greenery.",
        "public_id": "019e852e-3a11-774b-b098-4dc2a82d5473",
        "storage_key": "property/6737460151191760/019e852e-3a11-774b-b098-4dc2a82d5473.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by beautiful landscaping and ample seating for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1fb730c0-fc0f-4719-bccb-8437300fd3f3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-357b-7109-8e46-d7053775b76d.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, exercise bike, and weight machines.",
        "public_id": "019e852e-357b-7109-8e46-d7053775b76d",
        "storage_key": "property/6737460151191760/019e852e-357b-7109-8e46-d7053775b76d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring a variety of cardio and strength training equipment for residents.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, exercise bike, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1242a9c-9dce-41f1-83ac-42ff6b10ab49",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-28f7-733b-9c0d-6eeb38fef06f.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
        "public_id": "019e852e-28f7-733b-9c0d-6eeb38fef06f",
        "storage_key": "property/6737460151191760/019e852e-28f7-733b-9c0d-6eeb38fef06f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery. The perfect place to relax and unwind.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1df1d8a-c2c6-489e-b0e6-7f440748739b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-2909-700f-9bfc-62dba397b952.webp",
      "image_media": {
        "alt_text": "Picnic table and grill in a wooded area with apartment buildings in the background.",
        "public_id": "019e852e-2909-700f-9bfc-62dba397b952",
        "storage_key": "property/6737460151191760/019e852e-2909-700f-9bfc-62dba397b952.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the outdoors with a picnic table and grill area, perfect for al fresco dining and relaxation. Surrounded by trees and a short walk from your apartment.",
      "link": "",
      "alt_text": "Picnic table and grill in a wooded area with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bbdc22f2-b609-40c1-b4da-7218a77f5a5c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-2204-75d8-83b6-b49e09dbaff3.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
        "public_id": "019e852e-2204-75d8-83b6-b49e09dbaff3",
        "storage_key": "property/6737460151191760/019e852e-2204-75d8-83b6-b49e09dbaff3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of apartment buildings showcasing individual balconies and well-maintained green spaces.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f72c2053-2494-49c2-bbef-6619fd8ae1c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-178c-726c-8d13-63ebe62875a7.webp",
      "image_media": {
        "alt_text": "Patio with green chairs around a fire pit, next to a swimming pool and building.",
        "public_id": "019e852e-178c-726c-8d13-63ebe62875a7",
        "storage_key": "property/6737460151191760/019e852e-178c-726c-8d13-63ebe62875a7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy relaxing by the pool or gathering around the fire pit on the patio. This community offers beautiful outdoor spaces for residents.",
      "link": "",
      "alt_text": "Patio with green chairs around a fire pit, next to a swimming pool and building.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_514f63a3-b81f-492d-a7f8-2c9bc623295b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852e-11fe-7437-a4b3-e0fcf7fbc55c.webp",
      "image_media": {
        "alt_text": "Curving asphalt road leading to a low-rise apartment building complex entrance with mature trees and manicured lawns.",
        "public_id": "019e852e-11fe-7437-a4b3-e0fcf7fbc55c",
        "storage_key": "property/6737460151191760/019e852e-11fe-7437-a4b3-e0fcf7fbc55c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome home to our beautiful apartment community, featuring a scenic road and lush landscaping. Experience peaceful living surrounded by nature.",
      "link": "",
      "alt_text": "Curving asphalt road leading to a low-rise apartment building complex entrance with mature trees and manicured lawns.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7deae9ca-3ad1-4338-986c-4721ba947f15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-fc98-768c-8dd7-1617cbc3c388.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with grills and seating area",
        "public_id": "019e852d-fc98-768c-8dd7-1617cbc3c388",
        "storage_key": "property/6737460151191760/019e852d-fc98-768c-8dd7-1617cbc3c388.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's outdoor grilling station, featuring built-in grills and ample seating for residents and guests.",
      "link": "",
      "alt_text": "Outdoor grilling station with grills and seating area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_489b84ba-5c1b-444b-9eb5-7e067f3e5a66",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-f4aa-747b-84f6-b732d09e9755.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment",
        "public_id": "019e852d-f4aa-747b-84f6-b732d09e9755",
        "storage_key": "property/6737460151191760/019e852d-f4aa-747b-84f6-b732d09e9755.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious dog park, perfect for your furry friends to play and socialize. Features agility equipment for added fun.",
      "link": "",
      "alt_text": "Dog park with agility equipment",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c9c1f876-c9fa-4408-84ac-a7862b5d911e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-eb5b-745e-a54d-1de4cf5a0700.webp",
      "image_media": {
        "alt_text": "Large blue swimming pool with lounge chairs and trees in the background.",
        "public_id": "019e852d-eb5b-745e-a54d-1de4cf5a0700",
        "storage_key": "property/6737460151191760/019e852d-eb5b-745e-a54d-1de4cf5a0700.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. A perfect oasis for unwinding.",
      "link": "",
      "alt_text": "Large blue swimming pool with lounge chairs and trees in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_86881645-5d51-42bd-aca1-e49dcf6aae24",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-e85b-73ca-b393-91f0c057f4a6.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
        "public_id": "019e852d-e85b-73ca-b393-91f0c057f4a6",
        "storage_key": "property/6737460151191760/019e852d-e85b-73ca-b393-91f0c057f4a6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "An exterior shot of apartment buildings showcasing their balconies and lush, green surroundings.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c76c9058-97a9-4a8b-869b-1e970e5c0a65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-e92d-72a3-a43d-65abb5dcda93.webp",
      "image_media": {
        "alt_text": "Leasing center building entrance with signage and parking lot in foreground.",
        "public_id": "019e852d-e92d-72a3-a43d-65abb5dcda93",
        "storage_key": "property/6737460151191760/019e852d-e92d-72a3-a43d-65abb5dcda93.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing center, where our friendly staff is ready to assist you with finding your perfect home.",
      "link": "",
      "alt_text": "Leasing center building entrance with signage and parking lot in foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0abf54c5-c858-452a-b90a-6a9dd7c55e83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-e2dd-75cd-8c83-c5d1d3825542.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a covered pavilion.",
        "public_id": "019e852d-e2dd-75cd-8c83-c5d1d3825542",
        "storage_key": "property/6737460151191760/019e852d-e2dd-75cd-8c83-c5d1d3825542.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style swimming pool, surrounded by comfortable lounge chairs and lush landscaping. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a covered pavilion.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f25d9853-4628-4cfd-a666-c17c5a7e7e4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-b47f-7485-84ea-a7636eb2793d.webp",
      "image_media": {
        "alt_text": "Legacy at River Crossing apartment homes monument sign with landscaping.",
        "public_id": "019e852d-b47f-7485-84ea-a7636eb2793d",
        "storage_key": "property/6737460151191760/019e852d-b47f-7485-84ea-a7636eb2793d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Legacy at River Crossing apartment homes, featuring a prominent monument sign and lush landscaping.",
      "link": "",
      "alt_text": "Legacy at River Crossing apartment homes monument sign with landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d14187ff-9339-43f5-92c9-f8c74d03f981",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-b318-778a-9da3-499c7222e43e.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and landscaping.",
        "public_id": "019e852d-b318-778a-9da3-499c7222e43e",
        "storage_key": "property/6737460151191760/019e852d-b318-778a-9da3-499c7222e43e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully maintained apartment buildings featuring lush green lawns and professional landscaping, creating a welcoming atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5fd25b48-91d2-488c-84b9-77e6780b6f36",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-be17-71f0-944c-46f51e2c0dcd.webp",
      "image_media": {
        "alt_text": "Outdoor community area with picnic tables, ping pong table, and fire pit.",
        "public_id": "019e852d-be17-71f0-944c-46f51e2c0dcd",
        "storage_key": "property/6737460151191760/019e852d-be17-71f0-944c-46f51e2c0dcd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors at our community's recreational area, featuring picnic tables, a ping pong table, and a cozy fire pit area for gatherings.",
      "link": "",
      "alt_text": "Outdoor community area with picnic tables, ping pong table, and fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0e38dbfc-8f4d-4ceb-a1ac-61dcd75b04da",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e852d-9d58-70cb-bd5a-211a26ab15fe.webp",
      "image_media": {
        "alt_text": "Cozy community lounge with a coffee bar, fireplace, and comfortable seating.",
        "public_id": "019e852d-9d58-70cb-bd5a-211a26ab15fe",
        "storage_key": "property/6737460151191760/019e852d-9d58-70cb-bd5a-211a26ab15fe.webp",
        "width": 1500,
        "height": 998
      },
      "title": "Community",
      "description": "Relax and unwind in our community lounge, featuring a full coffee bar, a cozy fireplace, and ample seating areas for residents to enjoy.",
      "link": "",
      "alt_text": "Cozy community lounge with a coffee bar, fireplace, and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_4ead0161-1b27-4152-ba43-f2f11bf30556",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Bonefish Grill",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_long_description": "Contemporary grill chain offering a seafood-centric menu, plus steaks & cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-af6b-732c-a8dc-2e4ce90bff69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-af6b-732c-a8dc-2e4ce90bff69",
        "storage_key": "property/6737460151191760/019e1e42-af6b-732c-a8dc-2e4ce90bff69.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.bonefishgrill.com/georgia/macon/5080-riverside-drive?y_source=1_MTU1MDI3OTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=18292913454419106352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonefish-grill",
      "poi_latitude": "32.9281835",
      "poi_longitude": "-83.7146151",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 478-477-5256",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRMFqd5d173f0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_11a214ef-09eb-48a9-9970-4d2df65b5a21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr Suite 1500, Macon, GA 31210, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-39ea-73cf-a747-dd3b1ec44836.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-39ea-73cf-a747-dd3b1ec44836",
        "storage_key": "property/6737460151191760/019e1e40-39ea-73cf-a747-dd3b1ec44836.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/georgia/macon?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7708744444521463649&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "32.9245606",
      "poi_longitude": "-83.71236239999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 478-477-3777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRYb_3xzr2-mo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_3db31ef9-0616-47dc-b489-194f7800d46d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4950 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b254-70eb-83f5-3b99d0b59542.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b254-70eb-83f5-3b99d0b59542",
        "storage_key": "property/6737460151191760/019e1e42-b254-70eb-83f5-3b99d0b59542.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ga/macon/macon/6411?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:macon-ga-6411_pl:locurl_rd:1842",
      "poi_directions_map_url": "https://maps.google.com/?cid=1995066652428164787&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "32.9258061",
      "poi_longitude": "-83.7129846",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-477-0008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1aG2uf784gRs1410Yzmrxs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_e78beae5-b69e-4198-ad51-15330d77e395",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "La Parrilla Mexican Restaurant - Macon, GA",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Colorful, family-friendly chain serving a variety of Mexican dishes & margaritas.",
      "poi_long_description": "Colorful, family-friendly chain serving a variety of Mexican dishes & margaritas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-ac5f-71aa-974f-2453bed93334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-ac5f-71aa-974f-2453bed93334",
        "storage_key": "property/6737460151191760/019e1e42-ac5f-71aa-974f-2453bed93334.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.laparrilla.com/locations/macon-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=15270457504772701227&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-parrilla-mexican-restaurant---macon-ga",
      "poi_latitude": "32.9262633",
      "poi_longitude": "-83.71360949999999",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-475-5492",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRK7ysuTGQ69M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0f2fe52e-f11e-42d9-8e72-618d3a003e24",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Wild Wing Cafe",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr #100, Macon, GA 31210, USA",
      "poi_short_description": "Laid-back chain offering chicken wings in a variety of flavors amid a sports-bar atmosphere.",
      "poi_long_description": "Laid-back chain offering chicken wings in a variety of flavors amid a sports-bar atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b116-75b1-94a8-b74caeab26f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b116-75b1-94a8-b74caeab26f1",
        "storage_key": "property/6737460151191760/019e1e42-b116-75b1-94a8-b74caeab26f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.wildwingcafe.com/macon-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=1511991015014720980&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wild-wing-cafe",
      "poi_latitude": "32.92553",
      "poi_longitude": "-83.7154561",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 478-477-9453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgR1OWIOdGr-xQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_54bfbb5c-1e33-4062-a1fe-f9d274ddf61c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "5080 Riverside Dr Suite 1600, Macon, GA 31210, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b116-75b1-94a8-b2f0cb53805e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b116-75b1-94a8-b2f0cb53805e",
        "storage_key": "property/6737460151191760/019e1e42-b116-75b1-94a8-b2f0cb53805e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=3643954245952727895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "32.924868",
      "poi_longitude": "-83.712516",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 478-757-0169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRV-vJhxTtkTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_846795a6-636d-4960-89b4-3f3043389f4b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Chevo's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "4921 Riverside Dr Suite 2, Macon, GA 31210, USA",
      "poi_short_description": "Family-run eatery specializing in Mexican classics like tacos, burritos and fajitas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-af26-7169-9354-68377e590c92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-af26-7169-9354-68377e590c92",
        "storage_key": "property/6737460151191760/019e1e42-af26-7169-9354-68377e590c92.webp",
        "width": 1084,
        "height": 724
      },
      "poi_business_url": "https://www.chevosmexican.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9021911900138922139&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevos-mexican-restaurant",
      "poi_latitude": "32.926609",
      "poi_longitude": "-83.7114727",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-254-3468",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl_xn1yoH9IgRm2CmshJFNH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ab19bf66-f236-4121-9a5a-20473902a687",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Firehouse Subs Riverside Drive",
      "poi_type": "Restaurants",
      "poi_address": "4921 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_long_description": "Counter-serve sandwich chain offering made-to-order hot & cold subs, plus a variety of hot sauces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b442-73aa-92ae-7361a156012f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b442-73aa-92ae-7361a156012f",
        "storage_key": "property/6737460151191760/019e1e42-b442-73aa-92ae-7361a156012f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.firehousesubs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2427141912767226716&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "firehouse-subs-riverside-drive",
      "poi_latitude": "32.926426",
      "poi_longitude": "-83.71146999999999",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-405-8101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWl1gnwH9IgRXOPzybXwriE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_038a0fbb-af11-4fe3-bc0a-202fc762b71f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "CHICO & CHANG",
      "poi_type": "Restaurants",
      "poi_address": "3850 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Casual, counter-serve spot for Asian-Mexican fusion fare, like kimchi quesadillas.",
      "poi_long_description": "Casual, counter-serve spot for Asian-Mexican fusion fare, like kimchi quesadillas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b4b3-745e-a846-213a67d19199.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b4b3-745e-a846-213a67d19199",
        "storage_key": "property/6737460151191760/019e1e42-b4b3-745e-a846-213a67d19199.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://chicochang.fronteats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=984784309355419594&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chico--chang",
      "poi_latitude": "32.90207420000001",
      "poi_longitude": "-83.6883265",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-477-1688",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2wn447n484gRyheCmxyoqg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "korean_restaurant"
    },
    {
      "id": "custom_f06b495e-3096-4a92-9d6e-733be2c3b17f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "SUMO Steak & Sushi",
      "poi_type": "Restaurants",
      "poi_address": "3850 Riverside Dr suite b, Macon, GA 31210, USA",
      "poi_short_description": "Sprawling Japanese joint offering classic sushi rolls & hibachi dishes grilled tableside.",
      "poi_long_description": "Sprawling Japanese joint offering classic sushi rolls & hibachi dishes grilled tableside.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b8e6-7524-9039-71cb8ac1a17b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b8e6-7524-9039-71cb8ac1a17b",
        "storage_key": "property/6737460151191760/019e1e42-b8e6-7524-9039-71cb8ac1a17b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://sumosushimacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14973651219701480412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sumo-steak--sushi",
      "poi_latitude": "32.9021204",
      "poi_longitude": "-83.68848249999999",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-757-0560",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJG2Lv5Ln484gR3LvmVHMYzc8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_e4862240-376f-4bf7-96e7-61b98c6bc7b9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Pho Saigon",
      "poi_type": "Restaurants",
      "poi_address": "3076 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Big bowls of noodle soup, Vietnamese small plates & bubble tea in a bare-bones, strip mall locale.",
      "poi_long_description": "Big bowls of noodle soup, Vietnamese small plates & bubble tea in a bare-bones, strip mall locale.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b842-715d-a8cf-686dd48a99e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b842-715d-a8cf-686dd48a99e8",
        "storage_key": "property/6737460151191760/019e1e42-b842-715d-a8cf-686dd48a99e8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.phosaigonga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17272827368651119300&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-saigon",
      "poi_latitude": "32.8890804",
      "poi_longitude": "-83.67755520000001",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 25 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-477-1117",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-ywCz8z484gRxFoY9_lote8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_efb419c0-740b-4791-9631-c3bba07cc0b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "3072 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-3728-7786-a19e-78d15287171a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-3728-7786-a19e-78d15287171a",
        "storage_key": "property/6737460151191760/019e1e40-3728-7786-a19e-78d15287171a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ga/macon-bibb/macon/5027?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:macon-ga-5027_pl:locurl_rd:1014",
      "poi_directions_map_url": "https://maps.google.com/?cid=15186054543699349010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "32.889265",
      "poi_longitude": "-83.676442",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 478-471-7844",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB6uWPjP_84gREg7o-CW0v9I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_bcda1212-f00f-4d54-8c77-c809ee442e47",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Pedro’s Tacos & Tequila Bar",
      "poi_type": "Restaurants",
      "poi_address": "4040 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Casual restaurant serving tacos, fajitas, and other familiar Mexican eats with margaritas.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-bb06-7749-902d-0f638535d806.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-bb06-7749-902d-0f638535d806",
        "storage_key": "property/6737460151191760/019e1e42-bb06-7749-902d-0f638535d806.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://pedrosmacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10808283542850463310&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pedros-tacos--tequila-bar",
      "poi_latitude": "32.9058342",
      "poi_longitude": "-83.6925524",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-259-3593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ82kCWAD584gRTmZNE568_pU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_3df528e2-8d5b-418e-b39d-31064ba83b3d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Ingleside Village Pizza",
      "poi_type": "Restaurants",
      "poi_address": "2395 Ingleside Ave, Macon, GA 31204, USA",
      "poi_short_description": "Quirky sit-down pizzeria with New York-style pies, subs & an expansive roster of imported beers.",
      "poi_long_description": "Quirky sit-down pizzeria with New York-style pies, subs & an expansive roster of imported beers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-b95a-73db-a061-fc9ca28dbee5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-b95a-73db-a061-fc9ca28dbee5",
        "storage_key": "property/6737460151191760/019e1e42-b95a-73db-a061-fc9ca28dbee5.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "http://inglesidevillagepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6866813703610957645&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ingleside-village-pizza",
      "poi_latitude": "32.8539536",
      "poi_longitude": "-83.6572434",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 478-750-8488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4WyiysH-84gRTf-Ddq7SS18",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_a15e3ec3-9362-49bb-a629-929ed9817807",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Jim Shaw's Seafood Grill",
      "poi_type": "Restaurants",
      "poi_address": "3040 Vineville Ave, Macon, GA 31204, USA",
      "poi_short_description": "Local shrimp & seafood dishes plus a lengthy beer menu in a casual, family-friendly venue.",
      "poi_long_description": "Local shrimp & seafood dishes plus a lengthy beer menu in a casual, family-friendly venue.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-bbc7-723d-a0fb-da924bc6f59e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-bbc7-723d-a0fb-da924bc6f59e",
        "storage_key": "property/6737460151191760/019e1e42-bbc7-723d-a0fb-da924bc6f59e.webp",
        "width": 800,
        "height": 479
      },
      "poi_business_url": "https://www.jimshawseafoodga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16618564874235928506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jim-shaws-seafood-grill",
      "poi_latitude": "32.8495128",
      "poi_longitude": "-83.67362899999999",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-746-3697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5627-75fb-b464-13f840b03845",
        "storage_key": "property/6737460151191760/019e1e40-5627-75fb-b464-13f840b03845.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4yWBt7X-84gRut-dRbQAoeY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_e7d931c5-e00a-4af4-af00-b35c345dbee6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "4650 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-bbb5-74e8-bfa3-896d2eb3b964.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-bbb5-74e8-bfa3-896d2eb3b964",
        "storage_key": "property/6737460151191760/019e1e42-bbb5-74e8-bfa3-896d2eb3b964.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/macon/wesleyan-station/011/00355?cid=loc_01100355_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=6606103858955071840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "32.8732422",
      "poi_longitude": "-83.7097876",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-474-7410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-562c-766b-9b4d-c842a0b58ad3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-562c-766b-9b4d-c842a0b58ad3",
        "storage_key": "property/6737460151191760/019e1e40-562c-766b-9b4d-c842a0b58ad3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05zC1QL584gRYLFahnWYrVs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_130ecfff-ef10-4547-adaf-da3aa2d318f7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "The Shoppes at River Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "5080 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "Strip mall featuring a variety of dining & shopping options, from electronics to shoes.",
      "poi_long_description": "Strip mall featuring a variety of dining & shopping options, from electronics to shoes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-339e-7618-a05c-ae9c6ac66334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-339e-7618-a05c-ae9c6ac66334",
        "storage_key": "property/6737460151191760/019e1e40-339e-7618-a05c-ae9c6ac66334.webp",
        "width": 1280,
        "height": 510
      },
      "poi_business_url": "https://www.theshoppesatrivercrossing.com/en.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=6541699009911410211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-shoppes-at-river-crossing",
      "poi_latitude": "32.9267397",
      "poi_longitude": "-83.7152815",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 478-254-2941",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-93d1d8375f14",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjZ2rXnwH9IgRI05LEZfIyFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_02af21f8-bab0-4485-a8c2-46b85a54938d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Rivergate Shopping Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "121 Tom Hill Sr Blvd, Macon, GA 31210, USA",
      "poi_short_description": "Outdoors mall featuring retailers of a variety of products as well as restaurants.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-bcde-73d8-be37-4d509e704f22.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-bcde-73d8-be37-4d509e704f22",
        "storage_key": "property/6737460151191760/019e1e42-bcde-73d8-be37-4d509e704f22.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://google.com/url?q=https://business.google.com/website_shared/launch_bw.html?f=https://amzn.to/3VoIfw0",
      "poi_directions_map_url": "https://maps.google.com/?cid=6484849479140287204&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rivergate-shopping-center",
      "poi_latitude": "32.8974149",
      "poi_longitude": "-83.6879579",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 9 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 757-627-9088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-93d1d8375f14",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuUKU_7f484gR5KIIOj7Q_lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6bd101ad-ea5e-49b9-9ba4-cc7ae4caf0ab",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "5955 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Chain department store offering a variety of goods, including electronics, clothing, home furnishings, and groceries.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-bd41-755e-9891-23fe483277a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-bd41-755e-9891-23fe483277a0",
        "storage_key": "property/6737460151191760/019e1e42-bd41-755e-9891-23fe483277a0.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2890-macon-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13581640909292632283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.8830479",
      "poi_longitude": "-83.76007849999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-471-9150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-93d1d8375f14",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwb_a_yr484gR2_hMyXKue7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_2ce991a0-1fec-4bff-b642-f93d3a7d620e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "6035 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-be87-71eb-a0fd-5d9518d0d90a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-be87-71eb-a0fd-5d9518d0d90a",
        "storage_key": "property/6737460151191760/019e1e42-be87-71eb-a0fd-5d9518d0d90a.webp",
        "width": 622,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6035+zebulon+rd-macon-ga-31210/id=10634",
      "poi_directions_map_url": "https://maps.google.com/?cid=13653790034279264314&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "32.8804826",
      "poi_longitude": "-83.7634838",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-757-2027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6loaYD384gROvD7_rEBfL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_02583756-4355-442b-aa3d-a45b28eccf42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Wesleyan Ace Hardware",
      "poi_type": "Shopping & Retail",
      "poi_address": "5020 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_long_description": "Hardware store stocking household tools, garden supplies, home decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c064-727d-ba85-4421f08bfca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c064-727d-ba85-4421f08bfca4",
        "storage_key": "property/6737460151191760/019e1e42-c064-727d-ba85-4421f08bfca4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.acehardware.com/store-details/06672?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=06672",
      "poi_directions_map_url": "https://maps.google.com/?cid=3160069088101959559&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wesleyan-ace-hardware",
      "poi_latitude": "32.8818509",
      "poi_longitude": "-83.72834999999999",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-471-7732",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-93d1d8375f14",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVwVQLlL484gRh4cCxhfS2is",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_db66bd98-c5b2-4dc0-9824-aeb461a0dadd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Chevron",
      "poi_type": "Shopping & Retail",
      "poi_address": "3720 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c1fc-707a-9c5b-d865a2a7e2c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c1fc-707a-9c5b-d865a2a7e2c9",
        "storage_key": "property/6737460151191760/019e1e42-c1fc-707a-9c5b-d865a2a7e2c9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chevronwithtechron.com/station/3720-Riverside-Dr-Macon-GA-31210-id53094",
      "poi_directions_map_url": "https://maps.google.com/?cid=16855193307993349155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chevron",
      "poi_latitude": "32.9010235",
      "poi_longitude": "-83.6875567",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 478-474-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb02-743a-b990-c50a60e67fa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb02-743a-b990-c50a60e67fa0",
        "storage_key": "property/6737460151191760/019e1e42-fb02-743a-b990-c50a60e67fa0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxdDZLf484gRIxx8zwKt6ek",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_79bf68ed-e388-455f-8362-a0a15ec9e9b7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "175 Tom Hill Sr Blvd Ste, Macon, GA 31210, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-bf95-77c0-950a-fbe204f23be5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-bf95-77c0-950a-fbe204f23be5",
        "storage_key": "property/6737460151191760/019e1e42-bf95-77c0-950a-fbe204f23be5.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/ga/macon/175-tom-hill-sr-blvd-ste?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=15192261891866442663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "32.8977603",
      "poi_longitude": "-83.68714159999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-200-7210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-93d1d8375f14",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-93d1d8375f14.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyRrx5rf484gRpztn17LB1dI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_6c9768d9-a6d8-4b3f-bd1b-a20621c8e3e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Publix Super Market at Bass Plantation",
      "poi_type": "Shopping & Retail",
      "poi_address": "5451 Bowman Rd, Macon, GA 31210, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-348e-7726-93d2-34f30c6dec5c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-348e-7726-93d2-34f30c6dec5c",
        "storage_key": "property/6737460151191760/019e1e40-348e-7726-93d2-34f30c6dec5c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1263&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=11892024531365352692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-bass-plantation",
      "poi_latitude": "32.9244238",
      "poi_longitude": "-83.7355869",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-474-3064",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-562c-766b-9b4d-c842a0b58ad3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-562c-766b-9b4d-c842a0b58ad3",
        "storage_key": "property/6737460151191760/019e1e40-562c-766b-9b4d-c842a0b58ad3.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxXZagIkH9IgR9FRD_E31CKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_6fd33f72-6baf-402e-b679-cc654d86ca44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "McKibben Lane Elementary School",
      "poi_type": "Education",
      "poi_address": "990 Newport Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://lane.bcsdk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14516044096500581547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mckibben-lane-elementary-school",
      "poi_latitude": "32.8915435",
      "poi_longitude": "-83.6948846",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-779-3150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZXD-3MP484gRq8TSSzJZc8k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_29490116-6fd6-4686-b178-017951a4f8a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Howard Middle School",
      "poi_type": "Education",
      "poi_address": "6600 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c014-700f-8d00-b68586a7a37e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c014-700f-8d00-b68586a7a37e",
        "storage_key": "property/6737460151191760/019e1e42-c014-700f-8d00-b68586a7a37e.webp",
        "width": 1120,
        "height": 672
      },
      "poi_business_url": "https://howardms.bcsdk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4895612646294401225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "howard-middle-school",
      "poi_latitude": "32.9048802",
      "poi_longitude": "-83.77272479999999",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-779-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ5bDUSe7384gRybBJhMO18EM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_33d6d196-a7e0-46db-a34f-8149bf821dae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Howard High School",
      "poi_type": "Education",
      "poi_address": "6400 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c270-7063-9300-e3b65a7e17aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c270-7063-9300-e3b65a7e17aa",
        "storage_key": "property/6737460151191760/019e1e42-c270-7063-9300-e3b65a7e17aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://howardhs.bcsdk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5059986498121000169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "howard-high-school",
      "poi_latitude": "32.9025192",
      "poi_longitude": "-83.77365259999999",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-779-4850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJExRnzPL384gR6WTGPOmuOEY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_407da0d7-4a52-4ebb-a8b2-b91b5d35d476",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Academy for Classical Education ACE",
      "poi_type": "Education",
      "poi_address": "5665 New Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c2c5-71b4-a8e8-b91ce97de4a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c2c5-71b4-a8e8-b91ce97de4a3",
        "storage_key": "property/6737460151191760/019e1e42-c2c5-71b4-a8e8-b91ce97de4a3.webp",
        "width": 1280,
        "height": 736
      },
      "poi_business_url": "http://acemacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6483590218671999360&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "academy-for-classical-education-ace",
      "poi_latitude": "32.938716",
      "poi_longitude": "-83.72835490000001",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-238-5757",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJOQ1zh5kH9IgRgEkkzfNW-lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_a2ae4204-e475-48c2-a228-6f0bcf2f8d9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Tattnall Square Academy",
      "poi_type": "Education",
      "poi_address": "111 Trojan Trail, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c8c0-700b-96d8-dd247dbffbf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c8c0-700b-96d8-dd247dbffbf3",
        "storage_key": "property/6737460151191760/019e1e42-c8c0-700b-96d8-dd247dbffbf3.webp",
        "width": 1280,
        "height": 904
      },
      "poi_business_url": "http://www.tattnall.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16917662119906102040&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tattnall-square-academy",
      "poi_latitude": "32.8916356",
      "poi_longitude": "-83.7207753",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-477-6760",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJDb3Un1j484gRGMsVfxCcx-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_f73536e4-c908-46ac-8132-b04f6e4400a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "First Presbyterian Day School",
      "poi_type": "Education",
      "poi_address": "5671 Calvin Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-ca38-7159-bcb2-541ae4ec2a60.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-ca38-7159-bcb2-541ae4ec2a60",
        "storage_key": "property/6737460151191760/019e1e42-ca38-7159-bcb2-541ae4ec2a60.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.fpdmacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9865391176756041790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "first-presbyterian-day-school",
      "poi_latitude": "32.8730433",
      "poi_longitude": "-83.74979359999999",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-477-6505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJeYTO1s3584gRPhjRlAHp6Ig",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ef9abdc1-a090-4364-9756-947414480a25",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Wesleyan College",
      "poi_type": "Education",
      "poi_address": "4760 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-38ca-7542-a8ff-0a9c90506c15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-38ca-7542-a8ff-0a9c90506c15",
        "storage_key": "property/6737460151191760/019e1e40-38ca-7542-a8ff-0a9c90506c15.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.wesleyancollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127112479690987328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wesleyan-college",
      "poi_latitude": "32.87495560000001",
      "poi_longitude": "-83.7142284",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-447-6610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJp7ZxsQH584gRQBeU9j_fLLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_251a92d0-c5ae-4388-92ca-fc2224ba56ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "North Macon Presbyterian Church",
      "poi_type": "Education",
      "poi_address": "5707 Rivoli Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-ca19-77de-bafd-77913a24586e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-ca19-77de-bafd-77913a24586e",
        "storage_key": "property/6737460151191760/019e1e42-ca19-77de-bafd-77913a24586e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.nmpc.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3103467356341280301&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "north-macon-presbyterian-church",
      "poi_latitude": "32.9089826",
      "poi_longitude": "-83.7480712",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-477-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fafc-73cd-aff2-0be6882b9d6b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fafc-73cd-aff2-0be6882b9d6b",
        "storage_key": "property/6737460151191760/019e1e42-fafc-73cd-aff2-0be6882b9d6b.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYA8oRH484gRLR6-Ih67ESs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_3e68d251-09f7-437f-a6fb-617e10047c8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Tubman Museum",
      "poi_type": "Entertainment",
      "poi_address": "310 Cherry St, Macon, GA 31201, USA",
      "poi_short_description": "Established in 1981, this museum houses exhibits on African-American history, art & culture.",
      "poi_long_description": "Established in 1981, this museum houses exhibits on African-American history, art & culture.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d2c3-7326-becb-51e97bb728fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d2c3-7326-becb-51e97bb728fc",
        "storage_key": "property/6737460151191760/019e1e42-d2c3-7326-becb-51e97bb728fc.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.tubmanmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2145910552429185495&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tubman-museum",
      "poi_latitude": "32.8336795",
      "poi_longitude": "-83.6252367",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 19 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-743-8544",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5624-74e2-b183-d1c70047e010",
        "storage_key": "property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJR4NrE3r-84gR18lNJUfOxx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_5773cffc-463d-44b0-8492-351eca668dcd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Museum of Arts and Sciences",
      "poi_type": "Entertainment",
      "poi_address": "4182 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "Museum featuring fine-arts & science galleries, interactive exhibits, a minizoo & a planetarium.",
      "poi_long_description": "Museum featuring fine-arts & science galleries, interactive exhibits, a minizoo & a planetarium.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-409b-72cb-96d6-126489ba04de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-409b-72cb-96d6-126489ba04de",
        "storage_key": "property/6737460151191760/019e1e40-409b-72cb-96d6-126489ba04de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.masmacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10200504975877659134&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-of-arts-and-sciences",
      "poi_latitude": "32.8648216",
      "poi_longitude": "-83.695182",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-477-3232",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5624-74e2-b183-d1c70047e010",
        "storage_key": "property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJD_E6OCP584gR_tnKIDt5j40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_170e6315-8173-44cc-9045-2800e488d090",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "The Allman Brothers Band Museum at The Big House",
      "poi_type": "Entertainment",
      "poi_address": "2321 Vineville Ave, Macon, GA 31204, USA",
      "poi_short_description": "Museum honoring The Allman Brothers Band, with original instruments, art & personal mementos.",
      "poi_long_description": "Museum honoring The Allman Brothers Band, with original instruments, art & personal mementos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-cedb-77c8-9fcd-d3ef0ede2404.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-cedb-77c8-9fcd-d3ef0ede2404",
        "storage_key": "property/6737460151191760/019e1e42-cedb-77c8-9fcd-d3ef0ede2404.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebighousemuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11318196558373350832&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-allman-brothers-band-museum-at-the-big-house",
      "poi_latitude": "32.8460043",
      "poi_longitude": "-83.6558957",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 478-741-5551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5624-74e2-b183-d1c70047e010",
        "storage_key": "property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJzzBD9pX-84gRsG3kr81PEp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_13e682ab-1412-4342-b4d6-05776ccd7447",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "The Piedmont Grand Opera House",
      "poi_type": "Entertainment",
      "poi_address": "651 Mulberry St, Macon, GA 31201, USA",
      "poi_short_description": "This ornate 1884 concert hall features music performances, Broadway shows & other cultural events.",
      "poi_long_description": "This ornate 1884 concert hall features music performances, Broadway shows & other cultural events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-cdcc-73df-91c2-b18c3527d941.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-cdcc-73df-91c2-b18c3527d941",
        "storage_key": "property/6737460151191760/019e1e42-cdcc-73df-91c2-b18c3527d941.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.thegrandmacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435714553452345416&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-piedmont-grand-opera-house",
      "poi_latitude": "32.8385354",
      "poi_longitude": "-83.6283998",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-301-5470",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ93vbsWT-84gRSLjmdxgb05A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "opera_house"
    },
    {
      "id": "custom_7313a803-7d79-47f9-805c-2bb4cd670b39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Capitol Theatre Macon",
      "poi_type": "Entertainment",
      "poi_address": "382 2nd St, Macon, GA 31201, USA",
      "poi_short_description": "Restored circa-1916 movie palace presenting varied contemporary live music acts & films.",
      "poi_long_description": "Restored circa-1916 movie palace presenting varied contemporary live music acts & films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-cdb6-7438-9548-b1ad08075bd0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-cdb6-7438-9548-b1ad08075bd0",
        "storage_key": "property/6737460151191760/019e1e42-cdb6-7438-9548-b1ad08075bd0.webp",
        "width": 1280,
        "height": 855
      },
      "poi_business_url": "http://www.capitoltheatremacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4960493347563274676&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "capitol-theatre-macon",
      "poi_latitude": "32.8367603",
      "poi_longitude": "-83.628637",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-257-6391",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpxYaanv-84gRtIEy9Go210Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_69a57530-b262-45bc-a0c1-6a577bba8aa7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Macon City Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "415 1st St, Macon, GA 31201, USA",
      "poi_short_description": "Venue hosting concerts and other events in a 1920s building featuring a balcony.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-cdfe-73c8-bb43-42e7f8094398.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-cdfe-73c8-bb43-42e7f8094398",
        "storage_key": "property/6737460151191760/019e1e42-cdfe-73c8-bb43-42e7f8094398.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.maconcentreplex.org/auditorium/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5737100579101814560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-city-auditorium",
      "poi_latitude": "32.8373256",
      "poi_longitude": "-83.6310898",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-803-1593",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF10pxHz-84gRIC8NipRGnk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auditorium"
    },
    {
      "id": "custom_be8a0758-c868-419c-aced-005aaf2146d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Georgia Sports Hall of Fame",
      "poi_type": "Entertainment",
      "poi_address": "301 Cherry St, Macon, GA 31201, USA",
      "poi_short_description": "Georgia sports museum with tours & exhibitions highlighting artifacts & the state's top athletes.",
      "poi_long_description": "Georgia sports museum with tours & exhibitions highlighting artifacts & the state's top athletes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d406-739b-a8d2-f43b50c8cd0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d406-739b-a8d2-f43b50c8cd0f",
        "storage_key": "property/6737460151191760/019e1e42-d406-739b-a8d2-f43b50c8cd0f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.georgiasportshalloffame.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8301936821504479389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "georgia-sports-hall-of-fame",
      "poi_latitude": "32.8345274",
      "poi_longitude": "-83.62468199999999",
      "poi_miles_from_property": "8.8",
      "poi_walking_minutes": "3 hours 17 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-752-1585",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5624-74e2-b183-d1c70047e010",
        "storage_key": "property/6737460151191760/019e1e40-5624-74e2-b183-d1c70047e010.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJyVPWenr-84gRnZCCuY1nNnM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bc129f1a-b80a-440e-9073-774d5d167b83",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Hay House",
      "poi_type": "Entertainment",
      "poi_address": "934 Georgia Ave, Macon, GA 31201, USA",
      "poi_short_description": "19th-century mansion boasting marble statues, stained glass, ornate period furnishings & paintings.",
      "poi_long_description": "19th-century mansion boasting marble statues, stained glass, ornate period furnishings & paintings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-da9d-736f-bd44-32f268f374d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-da9d-736f-bd44-32f268f374d5",
        "storage_key": "property/6737460151191760/019e1e42-da9d-736f-bd44-32f268f374d5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hayhousemacon.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6000390080473172096&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hay-house",
      "poi_latitude": "32.8402785",
      "poi_longitude": "-83.6336046",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-742-8155",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHQLG7GL-84gRgIhhnPyqRVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_f27a71aa-d4c8-454e-a7dd-50d9a4483054",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Atrium Health Navicent The Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "777 Hemlock St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d4a7-7697-9335-89d1d4673a8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d4a7-7697-9335-89d1d4673a8e",
        "storage_key": "property/6737460151191760/019e1e42-d4a7-7697-9335-89d1d4673a8e.webp",
        "width": 1091,
        "height": 614
      },
      "poi_business_url": "https://navicenthealth.org/service-center/the-medical-center?utm_source=GMB&utm_medium=Organic&utm_campaign=AHN",
      "poi_directions_map_url": "https://maps.google.com/?cid=5959506398997543211&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-navicent-the-medical-center",
      "poi_latitude": "32.8338321",
      "poi_longitude": "-83.6365537",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-633-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5625-75f6-aaf0-1037536fbd6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5625-75f6-aaf0-1037536fbd6d",
        "storage_key": "property/6737460151191760/019e1e40-5625-75f6-aaf0-1037536fbd6d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJccj0KX7-84gRK3nqvH5rtFI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_4beaef36-b656-4d66-af19-a499625ec2cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Atrium Health Navicent Urgent Care North",
      "poi_type": "Health and Wellness",
      "poi_address": "3400 Riverside Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d771-730e-bcb3-cb512bddaad6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d771-730e-bcb3-cb512bddaad6",
        "storage_key": "property/6737460151191760/019e1e42-d771-730e-bcb3-cb512bddaad6.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "https://navicenthealth.org/service-center/urgent-care-navicent-health/north-urgent-care?utm_source=GMB&utm_medium=Organic&utm_campaign=AHN",
      "poi_directions_map_url": "https://maps.google.com/?cid=11660794173776044129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-navicent-urgent-care-north",
      "poi_latitude": "32.8939143",
      "poi_longitude": "-83.6804405",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-474-5600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQw8fVcr484gRYaDd_oR206E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2a7602b2-1b98-4684-a618-db3dadfdbbdc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Atrium Health Navicent Wellness Center",
      "poi_type": "Health and Wellness",
      "poi_address": "3797 Northside Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d9cf-730e-bd3d-d97f672ebf26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d9cf-730e-bd3d-d97f672ebf26",
        "storage_key": "property/6737460151191760/019e1e42-d9cf-730e-bd3d-d97f672ebf26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://navicenthealth.org/service-center/wellness-center?utm_source=GMB&utm_medium=Organic&utm_campaign=AHN",
      "poi_directions_map_url": "https://maps.google.com/?cid=8161841097392434994&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atrium-health-navicent-wellness-center",
      "poi_latitude": "32.8987922",
      "poi_longitude": "-83.6926345",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 478-477-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVUpcxLj484gRMq9CGzyvRHE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wellness_center"
    },
    {
      "id": "custom_94c2daf8-7223-418b-ac82-792ac8c469e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Kroger Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4650 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d83c-74d8-8950-8c200d7ff95c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d83c-74d8-8950-8c200d7ff95c",
        "storage_key": "property/6737460151191760/019e1e42-d83c-74d8-8950-8c200d7ff95c.webp",
        "width": 796,
        "height": 503
      },
      "poi_business_url": "https://www.kroger.com/rx/pharmacy/details/011/00355?cid=loc_01100355P_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17284863904744197123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-pharmacy",
      "poi_latitude": "32.873296",
      "poi_longitude": "-83.70982959999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-474-7413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb0c-7637-924d-9b9c1101bb0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb0c-7637-924d-9b9c1101bb0a",
        "storage_key": "property/6737460151191760/019e1e42-fb0c-7637-924d-9b9c1101bb0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05zC1QL584gRA8w_aSQs4O8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8c06ee4f-10d7-476f-b3b3-b12b22cf8dc0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "6035 Zebulon Rd, Macon, GA 31210, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d9db-7669-a216-f89c6e5f24e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d9db-7669-a216-f89c6e5f24e6",
        "storage_key": "property/6737460151191760/019e1e42-d9db-7669-a216-f89c6e5f24e6.webp",
        "width": 1280,
        "height": 584
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-6035+zebulon+rd-macon-ga-31210/id=10634",
      "poi_directions_map_url": "https://maps.google.com/?cid=6206669466636809590&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "32.8803647",
      "poi_longitude": "-83.7636318",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-757-2027",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb0c-7637-924d-9b9c1101bb0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb0c-7637-924d-9b9c1101bb0a",
        "storage_key": "property/6737460151191760/019e1e42-fb0c-7637-924d-9b9c1101bb0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7yw6aYD384gRdnUm3f6EIlY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_237471dd-a8c8-47bd-b7b0-9e6a607e31e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1544 Bass Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-dce2-7139-ba3d-3dc427532716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-dce2-7139-ba3d-3dc427532716",
        "storage_key": "property/6737460151191760/019e1e42-dce2-7139-ba3d-3dc427532716.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/macon-ga-pharmacies/1544-bass-rd-macon-ga-31210/storeid=10357?WT.mc_id=LS_GOOGLE_RX_10357",
      "poi_directions_map_url": "https://maps.google.com/?cid=17997084512597325173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "32.9270319",
      "poi_longitude": "-83.7356439",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 478-471-4494",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb0c-7637-924d-9b9c1101bb0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb0c-7637-924d-9b9c1101bb0a",
        "storage_key": "property/6737460151191760/019e1e42-fb0c-7637-924d-9b9c1101bb0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcavDWYkH9IgRdTUM9gJ9wvk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_90755556-5118-4daf-bb58-71cc845dbcac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Fitness Xtreme",
      "poi_type": "Health and Wellness",
      "poi_address": "2974 Riverside Dr, Macon, GA 31204, USA",
      "poi_short_description": "Friendly gym featuring free weights, classes and an exercise machine line-up.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-4662-704b-a1e8-6ed0fe86d48f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-4662-704b-a1e8-6ed0fe86d48f",
        "storage_key": "property/6737460151191760/019e1e40-4662-704b-a1e8-6ed0fe86d48f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.fitnessxtreme.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5899223611269633249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fitness-xtreme",
      "poi_latitude": "32.8850985",
      "poi_longitude": "-83.67377069999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 478-405-0420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr4-wCTL_84gR4dRSeJ5A3lE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ca9fda88-9b14-49c9-ab27-2ad58297c1a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "160 Tom Hill Sr Blvd, Macon, GA 31210, USA",
      "poi_short_description": "Members-only chain fitness center offering equipment, massage chairs, and tanning beds.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-409d-758c-a6ca-7eaccd0d0e2d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-409d-758c-a6ca-7eaccd0d0e2d",
        "storage_key": "property/6737460151191760/019e1e40-409d-758c-a6ca-7eaccd0d0e2d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/macon-ga?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=4452583688016435449&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "32.8999575",
      "poi_longitude": "-83.6907913",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 478-254-8970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV7aXCbj484gR-RjrAEbByj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bfe83f2d-30f7-4273-8f18-8e08fc56bc5f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4357 Forsyth Rd #250, Macon, GA 31210, USA",
      "poi_short_description": "Gym offering group exercise classes focused on fitness through heart-rate zone training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-4fc7-7079-bbc9-07c610c52638.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-4fc7-7079-bbc9-07c610c52638",
        "storage_key": "property/6737460151191760/019e1e40-4fc7-7079-bbc9-07c610c52638.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/macon-georgia-1148?utm_medium=seo&utm_source=gg&utm_term=corporate&utm_campaign=soci",
      "poi_directions_map_url": "https://maps.google.com/?cid=2545353446471769974&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "32.8690387",
      "poi_longitude": "-83.6968629",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 478-845-4505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcWvdjF_584gRdh_ERHnpUiM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_23b47ce5-0965-4001-9946-46296ede1dfb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Pure Barre",
      "poi_type": "Health and Wellness",
      "poi_address": "4420 Forsyth Rd Suite 140, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-def7-73ef-a4f4-830c867289dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-def7-73ef-a4f4-830c867289dc",
        "storage_key": "property/6737460151191760/019e1e42-def7-73ef-a4f4-830c867289dc.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.purebarre.com/location/macon-ga",
      "poi_directions_map_url": "https://maps.google.com/?cid=5588035193344403738&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pure-barre",
      "poi_latitude": "32.8685408",
      "poi_longitude": "-83.7000181",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-757-8561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ84uBtxj584gRGqms02awjE0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_28cc9da9-9a86-4357-927b-879220152a44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Theron Ussery Community Center (North Macon Park)",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "815 N Macon Park Dr, Macon, GA 31210, USA",
      "poi_short_description": "Place to play baseball, basketball, and softball, plus a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e0e2-73f8-a011-f857301a8b4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e0e2-73f8-a011-f857301a8b4d",
        "storage_key": "property/6737460151191760/019e1e42-e0e2-73f8-a011-f857301a8b4d.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "http://www.maconbibb.us/recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17809994881560256233&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "theron-ussery-community-center-north-macon-park",
      "poi_latitude": "32.887808",
      "poi_longitude": "-83.68212799999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-309-0964",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi9e82s3484gR6Z7svvvPKfc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "community_center"
    },
    {
      "id": "custom_c29cdbe6-a332-4347-bcd6-b89c1d5be09c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Amerson River Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2551 Pierce Dr N, Macon, GA 31204, USA",
      "poi_short_description": "This sprawling park with woods, wetlands & meadows offers a playground, canoe launch & trails.",
      "poi_long_description": "This sprawling park with woods, wetlands & meadows offers a playground, canoe launch & trails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-49f7-7613-8234-0293157ee64c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-49f7-7613-8234-0293157ee64c",
        "storage_key": "property/6737460151191760/019e1e40-49f7-7613-8234-0293157ee64c.webp",
        "width": 348,
        "height": 348
      },
      "poi_business_url": "http://maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6348967655751333775&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amerson-river-park",
      "poi_latitude": "32.8742247",
      "poi_longitude": "-83.6571728",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-803-0484",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5642-753c-ad14-9ab8618c5bd3",
        "storage_key": "property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJRY3JciD_84gRj7eA03EQHFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_66fcca0e-b856-4a81-b4d4-33ee264891af",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Ocmulgee Mounds National Historical Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1207 Emery Hwy, Macon, GA 31217, USA",
      "poi_short_description": "Historic park boasts Native American ceremonial earth mounds & a museum with artifacts on display.",
      "poi_long_description": "Historic park boasts Native American ceremonial earth mounds & a museum with artifacts on display.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-d528-7079-ac42-a4c303f3c4f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-d528-7079-ac42-a4c303f3c4f0",
        "storage_key": "property/6737460151191760/019e1e42-d528-7079-ac42-a4c303f3c4f0.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.nps.gov/ocmu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1067029869745100363&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ocmulgee-mounds-national-historical-park",
      "poi_latitude": "32.8381287",
      "poi_longitude": "-83.6020624",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "4 hours 5 mins",
      "poi_biking_minutes": "1 hour 18 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-752-8257",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJSV4UTxf-84gRS1bjXgPazg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_place"
    },
    {
      "id": "custom_37e98c88-9e42-431f-9e15-77fa87197f4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Tattnall Square Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1155 College St, Macon, GA 31201, USA",
      "poi_short_description": "City park with a playing field, playground, picnic areas & tennis courts, known for cultural events.",
      "poi_long_description": "City park with a playing field, playground, picnic areas & tennis courts, known for cultural events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e156-74e9-8473-f15e0c873716.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e156-74e9-8473-f15e0c873716",
        "storage_key": "property/6737460151191760/019e1e42-e156-74e9-8473-f15e0c873716.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maconbibb.us/recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2052102277676605321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tattnall-square-park",
      "poi_latitude": "32.8332856",
      "poi_longitude": "-83.6469206",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 9 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 478-219-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5642-753c-ad14-9ab8618c5bd3",
        "storage_key": "property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJR-8Jn5z-84gRiR-vJyaIehw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2cb8ffa9-edca-45b1-8202-2018f8d66b9e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Wesleyan Arboretum",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4760 Forsyth Rd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e1f4-7047-9748-1c93cec8e407.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e1f4-7047-9748-1c93cec8e407",
        "storage_key": "property/6737460151191760/019e1e42-e1f4-7047-9748-1c93cec8e407.webp",
        "width": 1280,
        "height": 1171
      },
      "poi_business_url": "https://www.wesleyancollege.edu/community/Arboretum/arboretum-home-page.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=8442985168664178042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wesleyan-arboretum",
      "poi_latitude": "32.8730649",
      "poi_longitude": "-83.71962669999999",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJARxfYgD584gReq0eLkeCK3U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_5e8a87f1-3186-465f-b95a-1be03aaefc80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Bloomfield Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1931 Rocky Creek Rd, Macon, GA 31206, USA",
      "poi_short_description": "County park featuring sports fields, basketball courts & a swimming pool, plus indoor event space.",
      "poi_long_description": "County park featuring sports fields, basketball courts & a swimming pool, plus indoor event space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e7cc-776e-90b6-b30021b3dba8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e7cc-776e-90b6-b30021b3dba8",
        "storage_key": "property/6737460151191760/019e1e42-e7cc-776e-90b6-b30021b3dba8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maconbibb.us/recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6416552564108103656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bloomfield-park",
      "poi_latitude": "32.7885166",
      "poi_longitude": "-83.6822682",
      "poi_miles_from_property": "12.6",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 15 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-803-1989",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5642-753c-ad14-9ab8618c5bd3",
        "storage_key": "property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TlPfYH784gR6A9Jio8sDFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_da286cd0-8046-4dca-9dad-94fa3c20cb18",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "South Bibb Recreation Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7035 Houston Rd, Macon, GA 31216, USA",
      "poi_short_description": "Relaxed venue offering a free gym and a pool as well as fitness and dance classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e330-771b-b080-db4afffe1203.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e330-771b-b080-db4afffe1203",
        "storage_key": "property/6737460151191760/019e1e42-e330-771b-b080-db4afffe1203.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.facebook.com/SouthBibbRec/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9726353987464500353&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "south-bibb-recreation-complex",
      "poi_latitude": "32.7101278",
      "poi_longitude": "-83.697068",
      "poi_miles_from_property": "18",
      "poi_walking_minutes": "6 hours 40 mins",
      "poi_biking_minutes": "1 hour 45 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 478-788-0430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJfQbQ1Kjl84gRgZSGTmvz-oY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_029beacc-516c-4168-abd4-66108dd77cbc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Riverview Neighborhood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2759 Riverview Rd, Macon, GA 31204, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e38b-7786-a12b-121664cbd2c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e38b-7786-a12b-121664cbd2c9",
        "storage_key": "property/6737460151191760/019e1e42-e38b-7786-a12b-121664cbd2c9.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5395297406815750380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverview-neighborhood-park",
      "poi_latitude": "32.878956",
      "poi_longitude": "-83.661057",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5642-753c-ad14-9ab8618c5bd3",
        "storage_key": "property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ331jViH_84gR7MjW7mfy30o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_6d9c7f2c-dfe3-4e99-b4d2-36c01fc88074",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Carolyn Crayton Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "150 Willie Smokie Glover Dr, Macon, GA 31201, USA",
      "poi_short_description": "Venerable park with grills, picnic shelters, playgrounds, a gazebo & annual cherry-blossom festival.",
      "poi_long_description": "Venerable park with grills, picnic shelters, playgrounds, a gazebo & annual cherry-blossom festival.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e82c-771f-80f4-53cf26f3e362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e82c-771f-80f4-53cf26f3e362",
        "storage_key": "property/6737460151191760/019e1e42-e82c-771f-80f4-53cf26f3e362.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.maconbibb.us/recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9038425699568800054&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carolyn-crayton-park",
      "poi_latitude": "32.8331789",
      "poi_longitude": "-83.6152137",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-621-6280",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5642-753c-ad14-9ab8618c5bd3",
        "storage_key": "property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJU9CFAv-84gRNlGPP0nwbn0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a55c83e0-5b27-425f-a4ca-fcbdb5e8baaa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Dr. William Green Lee Camellia Garden",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "976 Glenridge Dr, Macon, GA 31211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e782-76e8-a2e3-868a44e0cbe9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e782-76e8-a2e3-868a44e0cbe9",
        "storage_key": "property/6737460151191760/019e1e42-e782-76e8-a2e3-868a44e0cbe9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2440178694280737161&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dr-william-green-lee-camellia-garden",
      "poi_latitude": "32.8546513",
      "poi_longitude": "-83.6324455",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "1 hour 8 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5642-753c-ad14-9ab8618c5bd3",
        "storage_key": "property/6737460151191760/019e1e40-5642-753c-ad14-9ab8618c5bd3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX9fRNl_-84gRiXEUBZhB3SE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7024a6a1-9988-40b9-bda1-786a0bbc74eb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Middle Georgia Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1000 Terminal Dr, Macon, GA 31297, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-ebc9-7094-87d4-bae0622746b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-ebc9-7094-87d4-bae0622746b0",
        "storage_key": "property/6737460151191760/019e1e42-ebc9-7094-87d4-bae0622746b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://iflymacon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15662957178268972092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-georgia-regional-airport",
      "poi_latitude": "32.7018947",
      "poi_longitude": "-83.6502227",
      "poi_miles_from_property": "17.9",
      "poi_walking_minutes": "6 hours 37 mins",
      "poi_biking_minutes": "1 hour 43 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 478-219-1138",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb06-7459-af2e-340d7f11ab9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb06-7459-af2e-340d7f11ab9f",
        "storage_key": "property/6737460151191760/019e1e42-fb06-7459-af2e-340d7f11ab9f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ78hrbw7j84gRPHTgVpEAXtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_11bb1c48-3748-46c2-9c7d-a3d19db9e663",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Macon Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 Cherry St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-ec1b-730a-9d9c-a53ebe7841f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-ec1b-730a-9d9c-a53ebe7841f1",
        "storage_key": "property/6737460151191760/019e1e42-ec1b-730a-9d9c-a53ebe7841f1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://locations.greyhound.com/bus-stations/US/Macon/bus-station/bus-station-410685?utm_source=google&utm_medium=distrib&utm_campaign=google-distrib",
      "poi_directions_map_url": "https://maps.google.com/?cid=16615137765667952925&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-bus-station",
      "poi_latitude": "32.8331913",
      "poi_longitude": "-83.6247348",
      "poi_miles_from_property": "9",
      "poi_walking_minutes": "3 hours 21 mins",
      "poi_biking_minutes": "1 hour 4 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-743-5411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxQ0RVmH-84gRHdnQYMTTlOY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_f6fe4fdc-5cb9-4a1d-bfc7-7b31692bdca8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Groome Transportation",
      "poi_type": "Transportation & Transit",
      "poi_address": "4540 Sheraton Dr, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-ece8-772e-b64a-3e350c33011e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-ece8-772e-b64a-3e350c33011e",
        "storage_key": "property/6737460151191760/019e1e42-ece8-772e-b64a-3e350c33011e.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://groometransportation.com/macon/?utm_source=google&utm_medium=organic&utm_campaign=gbp_macon",
      "poi_directions_map_url": "https://maps.google.com/?cid=17724554326600688713&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "groome-transportation",
      "poi_latitude": "32.9177778",
      "poi_longitude": "-83.7044444",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 478-471-1616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9Gt0p3484gRSaQlV0BE-vU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport_shuttle_service"
    },
    {
      "id": "custom_ade762b8-4866-4165-90e6-462714982513",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Hampton Inn & Suites Macon I-75 North",
      "poi_type": "Transportation & Transit",
      "poi_address": "3954 River Pl Dr, Macon, GA 31210, USA",
      "poi_short_description": "Straightforward rooms in a riverside hotel with a pool & a gym, plus free Wi-Fi & hot breakfast.",
      "poi_long_description": "Straightforward rooms in a riverside hotel with a pool & a gym, plus free Wi-Fi & hot breakfast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-e90a-7121-b6f0-f23630e0da16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-e90a-7121-b6f0-f23630e0da16",
        "storage_key": "property/6737460151191760/019e1e42-e90a-7121-b6f0-f23630e0da16.webp",
        "width": 1023,
        "height": 682
      },
      "poi_business_url": "https://www.hilton.com/en/hotels/mcnnohx-hampton-suites-macon-i-75-north/?SEO_id=GMB-AMER-HX-MCNNOHX&y_source=1_MjA4Mzk0Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=8717092486049774034&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hampton-inn--suites-macon-i-75-north",
      "poi_latitude": "32.9035017",
      "poi_longitude": "-83.6831524",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 478-803-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb01-753d-b552-5941face8f99.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb01-753d-b552-5941face8f99",
        "storage_key": "property/6737460151191760/019e1e42-fb01-753d-b552-5941face8f99.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJlYdsWrH484gR0jk5UW5V-Xg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hotel"
    },
    {
      "id": "custom_79a9c67b-9eab-49cb-9106-9b0c368a8278",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Mercer University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1501 Mercer University Dr, Macon, GA 31207, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c8f7-76ad-8ac3-83a192d98c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c8f7-76ad-8ac3-83a192d98c90",
        "storage_key": "property/6737460151191760/019e1e42-c8f7-76ad-8ac3-83a192d98c90.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.mercer.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11661349141602039264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mercer-university",
      "poi_latitude": "32.8284878",
      "poi_longitude": "-83.64969909999999",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 800-637-2378",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS4T9n4n-84gR4PX-gkJv1aE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_5dc4d9a5-3ecc-4231-bc1e-ed11658c7ac6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Middle Georgia State University - Macon Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 University Pkwy, Macon, GA 31206, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-c876-720b-86c1-7f50513b3a58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-c876-720b-86c1-7f50513b3a58",
        "storage_key": "property/6737460151191760/019e1e42-c876-720b-86c1-7f50513b3a58.webp",
        "width": 600,
        "height": 337
      },
      "poi_business_url": "https://www.mga.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14021359213706895153&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middle-georgia-state-university---macon-campus",
      "poi_latitude": "32.8109077",
      "poi_longitude": "-83.7326161",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 56 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 478-471-2700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkX-PZwD784gRMV8moerflcI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8fb64697-bfa9-4c43-bae3-845b7411dd7d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Piedmont Macon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "350 Hospital Dr, Macon, GA 31217, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-f004-7746-97fa-9a4cc8ca37f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-f004-7746-97fa-9a4cc8ca37f4",
        "storage_key": "property/6737460151191760/019e1e42-f004-7746-97fa-9a4cc8ca37f4.webp",
        "width": 1195,
        "height": 672
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-macon-medical-center?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MjY4OTU4OTEtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10547206693762299691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-macon",
      "poi_latitude": "32.8473009",
      "poi_longitude": "-83.618713",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 28 mins",
      "poi_biking_minutes": "1 hour 10 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-765-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5625-75f6-aaf0-1037536fbd6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5625-75f6-aaf0-1037536fbd6d",
        "storage_key": "property/6737460151191760/019e1e40-5625-75f6-aaf0-1037536fbd6d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJhYCxJGr-84gRK_dSQps0X5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_6d115ee6-8596-4682-bf6d-1745e3175a2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Piedmont Macon North",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 Charter Blvd, Macon, GA 31210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-4a45-7307-8a7e-7387549163e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e40-4a45-7307-8a7e-7387549163e5",
        "storage_key": "property/6737460151191760/019e1e40-4a45-7307-8a7e-7387549163e5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmont.org/locations/piedmont-macon-north-hospital?utm_source=directorylisting&utm_medium=seo&utm_campaign=10223&y_source=1_MjY4OTU4OTMtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17716511181231489673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piedmont-macon-north",
      "poi_latitude": "32.8715199",
      "poi_longitude": "-83.6945317",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 478-757-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5625-75f6-aaf0-1037536fbd6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5625-75f6-aaf0-1037536fbd6d",
        "storage_key": "property/6737460151191760/019e1e40-5625-75f6-aaf0-1037536fbd6d.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ35QKcSP584gRiQKKoA2x3fU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_32fc1a16-02bc-49d8-8573-8fd2f5098688",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Amazon Fulfillment Center - SAV3",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6803-6999 Skipper Rd, Macon, GA 31216, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-ee12-72e1-959f-b855aeb64b81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-ee12-72e1-959f-b855aeb64b81",
        "storage_key": "property/6737460151191760/019e1e42-ee12-72e1-959f-b855aeb64b81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3291098560530863186&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amazon-fulfillment-center---sav3",
      "poi_latitude": "32.7199156",
      "poi_longitude": "-83.7239077",
      "poi_miles_from_property": "19.3",
      "poi_walking_minutes": "7 hours 10 mins",
      "poi_biking_minutes": "1 hour 48 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 478-345-8392",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNbyHE97l84gRUtQ9LbRUrC0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "storage"
    },
    {
      "id": "custom_8df7ac4c-dab4-4837-90c1-a1574314805e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Robins Air Force Base",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101 Habersham Lane, Robins AFB, GA 31098, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-f37e-72a8-8568-ebf4f491f91b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-f37e-72a8-8568-ebf4f491f91b",
        "storage_key": "property/6737460151191760/019e1e42-f37e-72a8-8568-ebf4f491f91b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2383279664767162776&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robins-air-force-base",
      "poi_latitude": "32.5929143",
      "poi_longitude": "-83.5749886",
      "poi_miles_from_property": "27.1",
      "poi_walking_minutes": "9 hours 57 mins",
      "poi_biking_minutes": "2 hours 37 mins",
      "poi_driving_minutes": "37 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb20-765f-be38-67106c20f635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb20-765f-be38-67106c20f635",
        "storage_key": "property/6737460151191760/019e1e42-fb20-765f-be38-67106c20f635.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJiwK1QQNf8YgRmNnbWjocEyE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_04dfc1c3-c92d-4413-83da-070571f74ee7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Macon-Bibb County Government Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "700 Poplar St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-f342-77df-802a-5d3eabe8fd36.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-f342-77df-802a-5d3eabe8fd36",
        "storage_key": "property/6737460151191760/019e1e42-f342-77df-802a-5d3eabe8fd36.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.maconbibb.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15610024968312878462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "macon-bibb-county-government-center",
      "poi_latitude": "32.8360042",
      "poi_longitude": "-83.6322394",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 11 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 478-751-7170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-fb20-765f-be38-67106c20f635.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e42-fb20-765f-be38-67106c20f635",
        "storage_key": "property/6737460151191760/019e1e42-fb20-765f-be38-67106c20f635.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE5oe-3z-84gRfnVE0wDzodg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_4f87d873-e1cc-4c56-935c-aec5a7e33d1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "Bibb County School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "484 Mulberry St, Macon, GA 31201, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-f0e3-779d-be65-f9b43d197c1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-f0e3-779d-be65-f9b43d197c1e",
        "storage_key": "property/6737460151191760/019e1e42-f0e3-779d-be65-f9b43d197c1e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bibb.k12.ga.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17572799608073800325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bibb-county-school-district",
      "poi_latitude": "32.8364787",
      "poi_longitude": "-83.62605599999999",
      "poi_miles_from_property": "8.6",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 478-765-8711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-565a-774a-b1d5-0cd00e8ac9c1",
        "storage_key": "property/6737460151191760/019e1e40-565a-774a-b1d5-0cd00e8ac9c1.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKQfQ6Xr-84gRhcpcjCMg3_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_01f0e984-c831-4d6b-92f0-e08f2c25f586",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "poi_name": "GEICO Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4295 Ocmulgee E Blvd, Macon, GA 31295, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e42-f2c8-72e6-b667-6e63c7203c2e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e42-f2c8-72e6-b667-6e63c7203c2e",
        "storage_key": "property/6737460151191760/019e1e42-f2c8-72e6-b667-6e63c7203c2e.webp",
        "width": 1085,
        "height": 1280
      },
      "poi_business_url": "https://www.geico.com/?y_source=1_MTQ5NTQ4MDktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13054691806611906697&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "geico-corporate-office",
      "poi_latitude": "32.809451",
      "poi_longitude": "-83.57070879999999",
      "poi_miles_from_property": "14",
      "poi_walking_minutes": "5 hours 11 mins",
      "poi_biking_minutes": "1 hour 49 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 478-741-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e40-5641-771d-8797-8f1c8ee19aa0",
        "storage_key": "property/6737460151191760/019e1e40-5641-771d-8797-8f1c8ee19aa0.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlV2BJRNW8YgRiSBOCQiVK7U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_de3a4f7d-77f2-4051-9c60-b9d463a99492",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_bbd8ed9c-0ca4-42a6-9440-69f623a92c3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_63bdbb50-83a4-4203-b3ec-6901ebc5d5ad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_005fba56-c85f-4971-bfea-6347cab3f199",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_d71f459b-9af6-4065-9b88-0964967ab3db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "custom_784ba53c-ab90-42c2-8645-9f842a4157fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "16:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_4c226f7b-f76f-4ba9-b0eb-da4e8e597a0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "rating": "5",
      "name": "AKA IMDevy",
      "text": "Summer graduation celebration There’s not much more I can say about this community. Andrea and her staff go above everything to make the residence happy and her desserts and functions that she puts on for us are always spectacular. You are going to live somewhere , where you love the staff and your apt this is the place, the vibe is great and where they show you so much appreciation. Legacy is where it’s at people. The manager Andrea goes above to put on great events❤️❤️❤️",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_e16e818f-d1e9-4184-82bd-42da88c9e2fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "rating": "5",
      "name": "Tabetha Leriche",
      "text": "I had a great experience with the maintenance team today. After dealing with AC issues, Mr. Willie and Antwan came out and got everything fixed quickly and without any problems. You can tell they knew exactly what they were doing and made sure everything was working properly before they left.\nI really appreciate the prompt response and the effort to finally get this resolved. Thank you to Ms. Michelle Ms.Andrea, Mr. Deontae and to the maintenance crew as well for helping make this happen. Much appreciated!",
      "date": "2026-05-06",
      "title": "false"
    },
    {
      "id": "custom_fb2c9db4-2840-4199-b749-7ea1de388641",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "rating": "5",
      "name": "Ryan Fleckenstein",
      "text": "Very friendly staff!",
      "date": "2026-02-25",
      "title": "false"
    },
    {
      "id": "custom_11829749-ee40-4fe6-8756-d35d1eae9abc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "rating": "4",
      "name": "Judgement Simms",
      "text": "Thanks to Darius for being knowledgeable and resilient in his area of expertise.",
      "date": "2026-01-14",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3a903203-2110-47d6-859a-fd626a2456ea",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019e1e40-7b86-74e1-b052-c277144de775.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a clubhouse in the background.",
        "public_id": "019e1e40-7b86-74e1-b052-c277144de775",
        "storage_key": "property/6737460151191760/019e1e40-7b86-74e1-b052-c277144de775.webp",
        "width": 1920,
        "height": 1280
      },
      "virtual_tour_title": "Community ",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=66d6801268021168998f4c29"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993e65-4d06-7413-bc00-96a2fadb4680",
      "lead_source": "LANDING_PAGE",
      "name": "rreaf-legacy-at-river-crossing-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760"
    },
    {
      "lead_collector_id": "019a271d-8f61-735a-ae67-9dc6ec990143",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-legacy-at-river-crossing-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "apartments-with-pool-macon-ga",
      "search_query": "apartments with pool Macon GA",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Macon, GA",
      "h2_subtitle": "Explore premium apartments with pool access at Legacy at River Crossing in Macon, GA. Discover our unbeatable amenities and schedule a tour today!",
      "page_copy": "Discover the ultimate in apartment living at Legacy at River Crossing, where residents enjoy exclusive access to our sparkling pool in the vibrant city of Macon, GA. We offer one, two, and three-bedroom floor plans designed to suit your lifestyle. With top-tier amenities such as hardwood floors, air conditioning, and door-to-door trash pickup, our community ensures comfort and convenience.\n\nLocated in Bibb County, our stunning property boasts a charming courtyard and a delightful picnic area, perfect for relaxing afternoons. Choose our short-term lease options and competitive pricing to fit your needs, while enjoying all the benefits of having a pool right at your doorstep. Schedule a tour today and make Legacy at River Crossing your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Macon, GA",
      "seo_description": "Discover apartments with pool access at Legacy at River Crossing in Macon, GA. Enjoy great amenities and spacious floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-bibb-county-ga",
      "search_query": "pet friendly apartments Bibb County GA",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Bibb County, GA",
      "h2_subtitle": "Discover pet-friendly living at Legacy at River Crossing in Bibb County, GA. Explore our variety of floor plans and amenities tailored for you and your pet.",
      "page_copy": "At Legacy at River Crossing, pets are part of the family! Located in Bibb County, GA, our community caters to pet owners with spacious apartment layouts and convenient amenities. Choose from our one, two, or three-bedroom floor plans, each designed to offer comfort and ease for both you and your furry friend.\n\nEnjoy strolling through our lush courtyard or relaxing at our picnic area—we provide the ideal environment for you and your pet. With amenities like hardwood floors, air conditioning, and a trash pickup service, you can focus on what matters most: spending quality time with your pet. Discover the perfect pet-friendly living in Bibb County today and see why Legacy at River Crossing is the ideal choice for you and your furry companions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Bibb County, GA",
      "seo_description": "Explore pet-friendly apartments at Legacy at River Crossing in Bibb County, GA. Enjoy amenities for you and your furry friend.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "units-with-air-conditioning-macon-31210",
      "search_query": "units with air conditioning Macon 31210",
      "category": "Amenity",
      "h1_title": "Units with Air Conditioning in Macon 31210",
      "h2_subtitle": "Experience comfort with air-conditioned units at Legacy at River Crossing in Macon, 31210. Explore our floor plans and exceptional amenities today.",
      "page_copy": "Stay cool at Legacy at River Crossing, where our units feature efficient air conditioning for optimal comfort in Macon's 31210 zip code. Choose from our range of floor plans, including one, two, and three-bedroom options, all designed to enhance your living experience.\n\nSituated in the scenic area of Bibb County, our property not only offers air-conditioned accommodation but also boasts additional amenities such as hardwood floors, a charming courtyard, and a convenient picnic area. Experience the ease of door-to-door trash pickup alongside short-term lease options and competitive pricing. Schedule a tour now to see why Legacy at River Crossing is the ideal choice for your next home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Units with Air Conditioning in Macon 31210",
      "seo_description": "Find units with air conditioning at Legacy at River Crossing in Macon 31210. Enjoy comfort with great amenities and floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "apartments-with-in-unit-washer-bibb-county",
      "search_query": "apartments with in-unit washer Bibb County",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Washer in Bibb County",
      "h2_subtitle": "Discover convenient living at Legacy at River Crossing in Bibb County, where in-unit washers enhance your lifestyle. Explore our floor plans today.",
      "page_copy": "Make laundry day a breeze at Legacy at River Crossing, offering apartments equipped with in-unit washers in Bibb County. Our community presents a range of floor plans from one to three bedrooms, ensuring a perfect fit for every lifestyle.\n\nLocated in the heart of Bibb County, our property combines convenience with comfort. Enjoy our lush courtyard, relax with friends in our picnic area, and take advantage of amenities such as air conditioning and hardwood floors. With flexible lease options and competitive pricing, Legacy at River Crossing makes it easy to find your perfect home. Schedule a tour to explore our spacious, well-equipped apartments today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Washer in Bibb County",
      "seo_description": "Find Bibb County apartments with in-unit washers at Legacy at River Crossing. Enjoy convenience and comfort with our varied floor plans and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "legacy-at-river-crossing-apartments-with-fitness-center",
      "search_query": "Legacy at River Crossing apartments with fitness center",
      "category": "Amenity",
      "h1_title": "Legacy at River Crossing: Apartments with Fitness Center",
      "h2_subtitle": "Discover fitness and comfort at Legacy at River Crossing, offering apartments with an on-site fitness center and a variety of amenities.",
      "page_copy": "At Legacy at River Crossing in Macon, enjoy the convenience of living in a community with a fully equipped fitness center. Our apartments offer more than just a place to live; they provide a lifestyle of health and wellness, right at home. Choose from our one, two, or three-bedroom floor plans designed with both comfort and style in mind.\n\nLocated in beautiful Bibb County, our residents benefit from much more than fitness facilities. Enjoy amenities like hardwood floors, air conditioning, and serene outdoor areas such as our picnic space and courtyard. With options for short-term leases and competitive pricing, Legacy at River Crossing is where you want to be. Schedule a tour today and experience apartment living that supports your active lifestyle!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Legacy at River Crossing: Apartments with Fitness Center",
      "seo_description": "Discover Legacy at River Crossing, apartments featuring a fitness center in Bibb County. Enjoy health-focused living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-macon-ga",
      "search_query": "1 bedroom apartments macon ga",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Macon, GA",
      "h2_subtitle": "Find your ideal 1 bedroom apartment at Legacy at River Crossing in Macon, GA. Enjoy comfort, style, and a range of amenities.",
      "page_copy": "Explore the perfect blend of comfort and convenience with our 1 bedroom apartments at Legacy at River Crossing in Macon, GA. Designed for those who appreciate style and functionality, our apartments feature amenities like air conditioning and hardwood floors.\n\nSituated in the vibrant community of Bibb County, Legacy at River Crossing offers much more than just a home. Residents enjoy a picturesque courtyard, a welcoming picnic area, and the convenience of door-to-door trash pickup. With flexible lease options and competitive rates, moving into your new 1 bedroom apartment has never been easier. Schedule a tour today and step into a world of comfort and style!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Macon, GA",
      "seo_description": "Discover 1 bedroom apartments in Macon, GA at Legacy at River Crossing. Enjoy comfort and amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-bibb-county",
      "search_query": "2 bedroom apartments bibb county",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Bibb County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Legacy at River Crossing, located in vibrant Bibb County. Experience comfort and quality living.",
      "page_copy": "At Legacy at River Crossing, our 2 bedroom apartments in Bibb County offer an ideal blend of space, comfort, and style. Perfect for families or roommates, these thoughtfully designed units include must-have features like air conditioning and durable hardwood floors.\n\nNestled in the welcoming neighborhood of Bibb County, residents enjoy a variety of lifestyle-enhancing amenities. These include a delightful courtyard, relaxing picnic area, and the convenience of door-to-door trash pickup. Additionally, we offer flexible lease terms and competitive pricing, making it easy to find the perfect 2 bedroom apartment that fits your needs. Visit us today and discover your new home at Legacy at River Crossing!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Bibb County",
      "seo_description": "Explore spacious 2 bedroom apartments in Bibb County at Legacy at River Crossing, offering comfort and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191760",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-near-31210",
      "search_query": "3 bedroom apartments near 31210",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments Near 31210",
      "h2_subtitle": "Explore spacious 3 bedroom apartments at Legacy at River Crossing, conveniently located near the 31210 area.",
      "page_copy": "Discover the perfect 3 bedroom apartment near the 31210 area at Legacy at River Crossing. Our spacious floor plans are ideal for families or individuals who crave extra room and comfort. Each apartment is thoughtfully designed to include amenities such as air conditioning and elegant hardwood flooring.\n\nSituated in the desirable Macon, GA area, Legacy at River Crossing offers much more than just beautiful apartments. Enjoy community features like our picnic area, a serene courtyard, and door-to-door trash pickup. With flexible leasing options and competitive pricing, settling into your new 3 bedroom apartment has never been easier. Schedule a tour today and experience the warmth and convenience of living at Legacy at River Crossing!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
      "featured_image_media": {
        "alt_text": "Comfortable seating area with a couch, chairs, and coffee table in a communal space.",
        "public_id": "019d076e-a68b-7143-9a8f-5c4800d9dde8",
        "storage_key": "property/6737460151191760/019d076e-a68b-7143-9a8f-5c4800d9dde8.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments Near 31210",
      "seo_description": "Find spacious 3 bedroom apartments near 31210 at Legacy at River Crossing, offering comfort and great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3353"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483459"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4857249"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WSDJ859N"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "478-606-1813"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "478-606-1851"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "478-606-1859"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "478-606-1784"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "478-606-1803"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "478-606-1549"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "478-606-1423"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "478-606-1707"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "478-606-1597"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "478-249-4751"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "478-245-4976"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "478-606-1738"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "478-312-5732"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "478-312-4890"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "478-395-8922"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "478-210-2212"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "478-606-8343"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "478-313-4045"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "17321198228"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "478-606-1840"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "478-210-3639"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "07816b911ee12eac"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "478-312-5845"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "478-606-1763"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "478-606-1759"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "478-344-6069"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "478-606-1855"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "478-606-1802"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "478-606-1816"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.legacyatrivercrossing.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191760/019e852e-9edd-743a-a2ba-92c4263fc0d0.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "478-606-1648"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "478-249-4751"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3353",
  "custom_repli_id": "5028483459",
  "custom_realpage_id": "4857249",
  "custom_knock_a_link": "https://www.legacyatrivercrossing.com?utm_knock=a",
  "custom_knock_g_link": "https://www.legacyatrivercrossing.com?utm_knock=g",
  "custom_knock_r_link": "https://www.legacyatrivercrossing.com?utm_knock=r",
  "custom_knock_w_link": "https://www.legacyatrivercrossing.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-WSDJ859N",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.legacyatrivercrossing.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.legacyatrivercrossing.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.legacyatrivercrossing.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.legacyatrivercrossing.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.legacyatrivercrossing.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.legacyatrivercrossing.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "478-606-1813",
  "custom_knock_ads_link": "https://www.legacyatrivercrossing.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.legacyatrivercrossing.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "478-606-1851",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.legacyatrivercrossing.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.legacyatrivercrossing.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.legacyatrivercrossing.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.legacyatrivercrossing.com?utm_knock=psa",
  "custom_knock_r_number": "478-606-1859",
  "custom_knock_w_number": "478-606-1784",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "478-606-1803",
  "custom_knock_amap_link": "https://www.legacyatrivercrossing.com?utm_knock=amap",
  "custom_knock_ar_number": "478-606-1549",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "478-606-1423",
  "custom_knock_fb_number": "478-606-1707",
  "custom_knock_fl_number": "478-606-1597",
  "custom_knock_gp_number": "478-249-4751",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.legacyatrivercrossing.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "478-245-4976",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.legacyatrivercrossing.com?utm_knock=bcard",
  "custom_knock_bnr_number": "478-606-1738",
  "custom_knock_cfres_link": "https://www.legacyatrivercrossing.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "478-312-5732",
  "custom_knock_lgp_number": "478-312-4890",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.legacyatrivercrossing.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "478-395-8922",
  "custom_knock_psa_number": "478-210-2212",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "478-606-8343",
  "custom_knock_bandit_link": "https://www.legacyatrivercrossing.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.legacyatrivercrossing.com?utm_knock=flyers",
  "custom_knock_osoc_number": "478-313-4045",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "17321198228",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "478-606-1840",
  "custom_knock_cfres_number": "478-210-3639",
  "custom_knock_chatgpt_link": "https://www.legacyatrivercrossing.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "07816b911ee12eac",
  "custom_knock_dirmail_link": "https://www.legacyatrivercrossing.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "478-312-5845",
  "custom_knock_propbro_link": "https://www.legacyatrivercrossing.com?utm_knock=propbro",
  "custom_knock_bandit_number": "478-606-1763",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "478-606-1759",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.legacyatrivercrossing.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "478-344-6069",
  "custom_knock_dirmail_number": "478-606-1855",
  "custom_knock_propbro_number": "478-606-1802",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "478-606-1816",
  "custom_knock_maintenance_link": "https://www.legacyatrivercrossing.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191760/019e852e-9edd-743a-a2ba-92c4263fc0d0.mp4",
  "custom_knock_maintenance_number": "478-606-1648",
  "custom_ppc_tracking_phone_number": "478-249-4751"
};

export const generatedAt = '2026-10-07T17:16:14.257Z';
